import ft from "@arcgis/core/geometry/Polygon";
import * as on from "@arcgis/core/geometry/geometryEngine";
import an from "@arcgis/core/layers/FeatureLayer";
import cn from "@arcgis/core/renderers/UniqueValueRenderer";
import nt from "@arcgis/core/symbols/SimpleFillSymbol";
import { whenOnce as ln } from "@arcgis/core/core/reactiveUtils";
import st from "@arcgis/core/Graphic";
import un from "@arcgis/core/geometry/Point";
import fn from "@arcgis/core/geometry/SpatialReference";
import * as dt from "@arcgis/core/geometry/operators/intersectsOperator";
import * as le from "@arcgis/core/geometry/operators/projectOperator";
import * as dn from "@arcgis/core/geometry/operators/areaOperator";
import * as hn from "@arcgis/core/geometry/operators/intersectionOperator";
import pn from "@arcgis/core/layers/Layer";
import mn from "@arcgis/core/portal/PortalItem";
import ar, { createContext as gn, useContext as yn } from "react";
function cr(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: kn } = Object.prototype, { getPrototypeOf: wt } = Object, { iterator: Be, toStringTag: lr } = Symbol, qe = ((t) => (e) => {
  const r = kn.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), K = (t) => (t = t.toLowerCase(), (e) => qe(e) === t), We = (t) => (e) => typeof e === t, { isArray: de } = Array, fe = We("undefined");
function Ee(t) {
  return t !== null && !fe(t) && t.constructor !== null && !fe(t.constructor) && B(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const ur = K("ArrayBuffer");
function wn(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && ur(t.buffer), e;
}
const bn = We("string"), B = We("function"), fr = We("number"), Se = (t) => t !== null && typeof t == "object", vn = (t) => t === !0 || t === !1, _e = (t) => {
  if (qe(t) !== "object")
    return !1;
  const e = wt(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(lr in t) && !(Be in t);
}, En = (t) => {
  if (!Se(t) || Ee(t))
    return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, Sn = K("Date"), Tn = K("File"), Rn = K("Blob"), An = K("FileList"), On = (t) => Se(t) && B(t.pipe), In = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || B(t.append) && ((e = qe(t)) === "formdata" || // detect form-data instance
  e === "object" && B(t.toString) && t.toString() === "[object FormData]"));
}, Cn = K("URLSearchParams"), [Fn, Pn, jn, xn] = ["ReadableStream", "Request", "Response", "Headers"].map(K), _n = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Te(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let n, s;
  if (typeof t != "object" && (t = [t]), de(t))
    for (n = 0, s = t.length; n < s; n++)
      e.call(null, t[n], n, t);
  else {
    if (Ee(t))
      return;
    const i = r ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let c;
    for (n = 0; n < o; n++)
      c = i[n], e.call(null, t[c], c, t);
  }
}
function dr(t, e) {
  if (Ee(t))
    return null;
  e = e.toLowerCase();
  const r = Object.keys(t);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], e === s.toLowerCase())
      return s;
  return null;
}
const ne = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), hr = (t) => !fe(t) && t !== ne;
function ht() {
  const { caseless: t, skipUndefined: e } = hr(this) && this || {}, r = {}, n = (s, i) => {
    const o = t && dr(r, i) || i;
    _e(r[o]) && _e(s) ? r[o] = ht(r[o], s) : _e(s) ? r[o] = ht({}, s) : de(s) ? r[o] = s.slice() : (!e || !fe(s)) && (r[o] = s);
  };
  for (let s = 0, i = arguments.length; s < i; s++)
    arguments[s] && Te(arguments[s], n);
  return r;
}
const Mn = (t, e, r, { allOwnKeys: n } = {}) => (Te(e, (s, i) => {
  r && B(s) ? t[i] = cr(s, r) : t[i] = s;
}, { allOwnKeys: n }), t), Ln = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Nn = (t, e, r, n) => {
  t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, $n = (t, e, r, n) => {
  let s, i, o;
  const c = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; )
      o = s[i], (!n || n(o, t, e)) && !c[o] && (e[o] = t[o], c[o] = !0);
    t = r !== !1 && wt(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, Dn = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const n = t.indexOf(e, r);
  return n !== -1 && n === r;
}, Un = (t) => {
  if (!t)
    return null;
  if (de(t))
    return t;
  let e = t.length;
  if (!fr(e))
    return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, Bn = ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && wt(Uint8Array)), qn = (t, e) => {
  const n = (t && t[Be]).call(t);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const i = s.value;
    e.call(t, i[0], i[1]);
  }
}, Wn = (t, e) => {
  let r;
  const n = [];
  for (; (r = t.exec(e)) !== null; )
    n.push(r);
  return n;
}, Vn = K("HTMLFormElement"), Hn = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), Ut = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), Gn = K("RegExp"), pr = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), n = {};
  Te(r, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (n[i] = o || s);
  }), Object.defineProperties(t, n);
}, zn = (t) => {
  pr(t, (e, r) => {
    if (B(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = t[r];
    if (B(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Jn = (t, e) => {
  const r = {}, n = (s) => {
    s.forEach((i) => {
      r[i] = !0;
    });
  };
  return de(t) ? n(t) : n(String(t).split(e)), r;
}, Kn = () => {
}, Yn = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function Qn(t) {
  return !!(t && B(t.append) && t[lr] === "FormData" && t[Be]);
}
const Xn = (t) => {
  const e = new Array(10), r = (n, s) => {
    if (Se(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (Ee(n))
        return n;
      if (!("toJSON" in n)) {
        e[s] = n;
        const i = de(n) ? [] : {};
        return Te(n, (o, c) => {
          const l = r(o, s + 1);
          !fe(l) && (i[c] = l);
        }), e[s] = void 0, i;
      }
    }
    return n;
  };
  return r(t, 0);
}, Zn = K("AsyncFunction"), es = (t) => t && (Se(t) || B(t)) && B(t.then) && B(t.catch), mr = ((t, e) => t ? setImmediate : e ? ((r, n) => (ne.addEventListener("message", ({ source: s, data: i }) => {
  s === ne && i === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), ne.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  B(ne.postMessage)
), ts = typeof queueMicrotask < "u" ? queueMicrotask.bind(ne) : typeof process < "u" && process.nextTick || mr, rs = (t) => t != null && B(t[Be]), d = {
  isArray: de,
  isArrayBuffer: ur,
  isBuffer: Ee,
  isFormData: In,
  isArrayBufferView: wn,
  isString: bn,
  isNumber: fr,
  isBoolean: vn,
  isObject: Se,
  isPlainObject: _e,
  isEmptyObject: En,
  isReadableStream: Fn,
  isRequest: Pn,
  isResponse: jn,
  isHeaders: xn,
  isUndefined: fe,
  isDate: Sn,
  isFile: Tn,
  isBlob: Rn,
  isRegExp: Gn,
  isFunction: B,
  isStream: On,
  isURLSearchParams: Cn,
  isTypedArray: Bn,
  isFileList: An,
  forEach: Te,
  merge: ht,
  extend: Mn,
  trim: _n,
  stripBOM: Ln,
  inherits: Nn,
  toFlatObject: $n,
  kindOf: qe,
  kindOfTest: K,
  endsWith: Dn,
  toArray: Un,
  forEachEntry: qn,
  matchAll: Wn,
  isHTMLForm: Vn,
  hasOwnProperty: Ut,
  hasOwnProp: Ut,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: pr,
  freezeMethods: zn,
  toObjectSet: Jn,
  toCamelCase: Hn,
  noop: Kn,
  toFiniteNumber: Yn,
  findKey: dr,
  global: ne,
  isContextDefined: hr,
  isSpecCompliantForm: Qn,
  toJSONObject: Xn,
  isAsyncFn: Zn,
  isThenable: es,
  setImmediate: mr,
  asap: ts,
  isIterable: rs
};
function S(t, e, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), n && (this.request = n), s && (this.response = s, this.status = s.status ? s.status : null);
}
d.inherits(S, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: d.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const gr = S.prototype, yr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  yr[t] = { value: t };
});
Object.defineProperties(S, yr);
Object.defineProperty(gr, "isAxiosError", { value: !0 });
S.from = (t, e, r, n, s, i) => {
  const o = Object.create(gr);
  d.toFlatObject(t, o, function(f) {
    return f !== Error.prototype;
  }, (u) => u !== "isAxiosError");
  const c = t && t.message ? t.message : "Error", l = e == null && t ? t.code : e;
  return S.call(o, c, l, r, n, s), t && o.cause == null && Object.defineProperty(o, "cause", { value: t, configurable: !0 }), o.name = t && t.name || "Error", i && Object.assign(o, i), o;
};
const ns = null;
function pt(t) {
  return d.isPlainObject(t) || d.isArray(t);
}
function kr(t) {
  return d.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Bt(t, e, r) {
  return t ? t.concat(e).map(function(s, i) {
    return s = kr(s), !r && i ? "[" + s + "]" : s;
  }).join(r ? "." : "") : e;
}
function ss(t) {
  return d.isArray(t) && !t.some(pt);
}
const is = d.toFlatObject(d, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Ve(t, e, r) {
  if (!d.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = d.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, y) {
    return !d.isUndefined(y[g]);
  });
  const n = r.metaTokens, s = r.visitor || f, i = r.dots, o = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && d.isSpecCompliantForm(e);
  if (!d.isFunction(s))
    throw new TypeError("visitor must be a function");
  function u(p) {
    if (p === null)
      return "";
    if (d.isDate(p))
      return p.toISOString();
    if (d.isBoolean(p))
      return p.toString();
    if (!l && d.isBlob(p))
      throw new S("Blob is not supported. Use a Buffer instead.");
    return d.isArrayBuffer(p) || d.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function f(p, g, y) {
    let A = p;
    if (p && !y && typeof p == "object") {
      if (d.endsWith(g, "{}"))
        g = n ? g : g.slice(0, -2), p = JSON.stringify(p);
      else if (d.isArray(p) && ss(p) || (d.isFileList(p) || d.endsWith(g, "[]")) && (A = d.toArray(p)))
        return g = kr(g), A.forEach(function(I, x) {
          !(d.isUndefined(I) || I === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Bt([g], x, i) : o === null ? g : g + "[]",
            u(I)
          );
        }), !1;
    }
    return pt(p) ? !0 : (e.append(Bt(y, g, i), u(p)), !1);
  }
  const h = [], w = Object.assign(is, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: pt
  });
  function b(p, g) {
    if (!d.isUndefined(p)) {
      if (h.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      h.push(p), d.forEach(p, function(A, E) {
        (!(d.isUndefined(A) || A === null) && s.call(
          e,
          A,
          d.isString(E) ? E.trim() : E,
          g,
          w
        )) === !0 && b(A, g ? g.concat(E) : [E]);
      }), h.pop();
    }
  }
  if (!d.isObject(t))
    throw new TypeError("data must be an object");
  return b(t), e;
}
function qt(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function bt(t, e) {
  this._pairs = [], t && Ve(t, this, e);
}
const wr = bt.prototype;
wr.append = function(e, r) {
  this._pairs.push([e, r]);
};
wr.toString = function(e) {
  const r = e ? function(n) {
    return e.call(this, n, qt);
  } : qt;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function os(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function br(t, e, r) {
  if (!e)
    return t;
  const n = r && r.encode || os;
  d.isFunction(r) && (r = {
    serialize: r
  });
  const s = r && r.serialize;
  let i;
  if (s ? i = s(e, r) : i = d.isURLSearchParams(e) ? e.toString() : new bt(e, r).toString(n), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class as {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    d.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const Wt = as, vr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, cs = typeof URLSearchParams < "u" ? URLSearchParams : bt, ls = typeof FormData < "u" ? FormData : null, us = typeof Blob < "u" ? Blob : null, fs = {
  isBrowser: !0,
  classes: {
    URLSearchParams: cs,
    FormData: ls,
    Blob: us
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, vt = typeof window < "u" && typeof document < "u", mt = typeof navigator == "object" && navigator || void 0, ds = vt && (!mt || ["ReactNative", "NativeScript", "NS"].indexOf(mt.product) < 0), hs = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), ps = vt && window.location.href || "http://localhost", ms = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: vt,
  hasStandardBrowserEnv: ds,
  hasStandardBrowserWebWorkerEnv: hs,
  navigator: mt,
  origin: ps
}, Symbol.toStringTag, { value: "Module" })), M = {
  ...ms,
  ...fs
};
function gs(t, e) {
  return Ve(t, new M.classes.URLSearchParams(), {
    visitor: function(r, n, s, i) {
      return M.isNode && d.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...e
  });
}
function ys(t) {
  return d.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function ks(t) {
  const e = {}, r = Object.keys(t);
  let n;
  const s = r.length;
  let i;
  for (n = 0; n < s; n++)
    i = r[n], e[i] = t[i];
  return e;
}
function Er(t) {
  function e(r, n, s, i) {
    let o = r[i++];
    if (o === "__proto__")
      return !0;
    const c = Number.isFinite(+o), l = i >= r.length;
    return o = !o && d.isArray(s) ? s.length : o, l ? (d.hasOwnProp(s, o) ? s[o] = [s[o], n] : s[o] = n, !c) : ((!s[o] || !d.isObject(s[o])) && (s[o] = []), e(r, n, s[o], i) && d.isArray(s[o]) && (s[o] = ks(s[o])), !c);
  }
  if (d.isFormData(t) && d.isFunction(t.entries)) {
    const r = {};
    return d.forEachEntry(t, (n, s) => {
      e(ys(n), s, r, 0);
    }), r;
  }
  return null;
}
function ws(t, e, r) {
  if (d.isString(t))
    try {
      return (e || JSON.parse)(t), d.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(t);
}
const Et = {
  transitional: vr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, i = d.isObject(e);
    if (i && d.isHTMLForm(e) && (e = new FormData(e)), d.isFormData(e))
      return s ? JSON.stringify(Er(e)) : e;
    if (d.isArrayBuffer(e) || d.isBuffer(e) || d.isStream(e) || d.isFile(e) || d.isBlob(e) || d.isReadableStream(e))
      return e;
    if (d.isArrayBufferView(e))
      return e.buffer;
    if (d.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let c;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return gs(e, this.formSerializer).toString();
      if ((c = d.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Ve(
          c ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || s ? (r.setContentType("application/json", !1), ws(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || Et.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (d.isResponse(e) || d.isReadableStream(e))
      return e;
    if (e && d.isString(e) && (n && !this.responseType || s)) {
      const o = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (c) {
        if (o)
          throw c.name === "SyntaxError" ? S.from(c, S.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: M.classes.FormData,
    Blob: M.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
d.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Et.headers[t] = {};
});
const St = Et, bs = d.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), vs = (t) => {
  const e = {};
  let r, n, s;
  return t && t.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), r = o.substring(0, s).trim().toLowerCase(), n = o.substring(s + 1).trim(), !(!r || e[r] && bs[r]) && (r === "set-cookie" ? e[r] ? e[r].push(n) : e[r] = [n] : e[r] = e[r] ? e[r] + ", " + n : n);
  }), e;
}, Vt = Symbol("internals");
function we(t) {
  return t && String(t).trim().toLowerCase();
}
function Me(t) {
  return t === !1 || t == null ? t : d.isArray(t) ? t.map(Me) : String(t);
}
function Es(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(t); )
    e[n[1]] = n[2];
  return e;
}
const Ss = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function it(t, e, r, n, s) {
  if (d.isFunction(n))
    return n.call(this, e, r);
  if (s && (e = r), !!d.isString(e)) {
    if (d.isString(n))
      return e.indexOf(n) !== -1;
    if (d.isRegExp(n))
      return n.test(e);
  }
}
function Ts(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, n) => r.toUpperCase() + n);
}
function Rs(t, e) {
  const r = d.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(t, n + r, {
      value: function(s, i, o) {
        return this[n].call(this, e, s, i, o);
      },
      configurable: !0
    });
  });
}
class He {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, n) {
    const s = this;
    function i(c, l, u) {
      const f = we(l);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const h = d.findKey(s, f);
      (!h || s[h] === void 0 || u === !0 || u === void 0 && s[h] !== !1) && (s[h || l] = Me(c));
    }
    const o = (c, l) => d.forEach(c, (u, f) => i(u, f, l));
    if (d.isPlainObject(e) || e instanceof this.constructor)
      o(e, r);
    else if (d.isString(e) && (e = e.trim()) && !Ss(e))
      o(vs(e), r);
    else if (d.isObject(e) && d.isIterable(e)) {
      let c = {}, l, u;
      for (const f of e) {
        if (!d.isArray(f))
          throw TypeError("Object iterator must return a key-value pair");
        c[u = f[0]] = (l = c[u]) ? d.isArray(l) ? [...l, f[1]] : [l, f[1]] : f[1];
      }
      o(c, r);
    } else
      e != null && i(r, e, n);
    return this;
  }
  get(e, r) {
    if (e = we(e), e) {
      const n = d.findKey(this, e);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return Es(s);
        if (d.isFunction(r))
          return r.call(this, s, n);
        if (d.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = we(e), e) {
      const n = d.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!r || it(this, this[n], n, r)));
    }
    return !1;
  }
  delete(e, r) {
    const n = this;
    let s = !1;
    function i(o) {
      if (o = we(o), o) {
        const c = d.findKey(n, o);
        c && (!r || it(n, n[c], c, r)) && (delete n[c], s = !0);
      }
    }
    return d.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const i = r[n];
      (!e || it(this, this[i], i, e, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const r = this, n = {};
    return d.forEach(this, (s, i) => {
      const o = d.findKey(n, i);
      if (o) {
        r[o] = Me(s), delete r[i];
        return;
      }
      const c = e ? Ts(i) : String(i).trim();
      c !== i && delete r[i], r[c] = Me(s), n[c] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return d.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = e && d.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const n = new this(e);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(e) {
    const n = (this[Vt] = this[Vt] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const c = we(o);
      n[c] || (Rs(s, o), n[c] = !0);
    }
    return d.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
He.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
d.reduceDescriptors(He.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(n) {
      this[r] = n;
    }
  };
});
d.freezeMethods(He);
const J = He;
function ot(t, e) {
  const r = this || St, n = e || r, s = J.from(n.headers);
  let i = n.data;
  return d.forEach(t, function(c) {
    i = c.call(r, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function Sr(t) {
  return !!(t && t.__CANCEL__);
}
function he(t, e, r) {
  S.call(this, t ?? "canceled", S.ERR_CANCELED, e, r), this.name = "CanceledError";
}
d.inherits(he, S, {
  __CANCEL__: !0
});
function Tr(t, e, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? t(r) : e(new S(
    "Request failed with status code " + r.status,
    [S.ERR_BAD_REQUEST, S.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function As(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function Os(t, e) {
  t = t || 10;
  const r = new Array(t), n = new Array(t);
  let s = 0, i = 0, o;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const u = Date.now(), f = n[i];
    o || (o = u), r[s] = l, n[s] = u;
    let h = i, w = 0;
    for (; h !== s; )
      w += r[h++], h = h % t;
    if (s = (s + 1) % t, s === i && (i = (i + 1) % t), u - o < e)
      return;
    const b = f && u - f;
    return b ? Math.round(w * 1e3 / b) : void 0;
  };
}
function Is(t, e) {
  let r = 0, n = 1e3 / e, s, i;
  const o = (u, f = Date.now()) => {
    r = f, s = null, i && (clearTimeout(i), i = null), t(...u);
  };
  return [(...u) => {
    const f = Date.now(), h = f - r;
    h >= n ? o(u, f) : (s = u, i || (i = setTimeout(() => {
      i = null, o(s);
    }, n - h)));
  }, () => s && o(s)];
}
const De = (t, e, r = 3) => {
  let n = 0;
  const s = Os(50, 250);
  return Is((i) => {
    const o = i.loaded, c = i.lengthComputable ? i.total : void 0, l = o - n, u = s(l), f = o <= c;
    n = o;
    const h = {
      loaded: o,
      total: c,
      progress: c ? o / c : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && c && f ? (c - o) / u : void 0,
      event: i,
      lengthComputable: c != null,
      [e ? "download" : "upload"]: !0
    };
    t(h);
  }, r);
}, Ht = (t, e) => {
  const r = t != null;
  return [(n) => e[0]({
    lengthComputable: r,
    total: t,
    loaded: n
  }), e[1]];
}, Gt = (t) => (...e) => d.asap(() => t(...e)), Cs = M.hasStandardBrowserEnv ? ((t, e) => (r) => (r = new URL(r, M.origin), t.protocol === r.protocol && t.host === r.host && (e || t.port === r.port)))(
  new URL(M.origin),
  M.navigator && /(msie|trident)/i.test(M.navigator.userAgent)
) : () => !0, Fs = M.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, n, s, i, o) {
      if (typeof document > "u")
        return;
      const c = [`${t}=${encodeURIComponent(e)}`];
      d.isNumber(r) && c.push(`expires=${new Date(r).toUTCString()}`), d.isString(n) && c.push(`path=${n}`), d.isString(s) && c.push(`domain=${s}`), i === !0 && c.push("secure"), d.isString(o) && c.push(`SameSite=${o}`), document.cookie = c.join("; ");
    },
    read(t) {
      if (typeof document > "u")
        return null;
      const e = document.cookie.match(new RegExp("(?:^|; )" + t + "=([^;]*)"));
      return e ? decodeURIComponent(e[1]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Ps(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function js(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Rr(t, e, r) {
  let n = !Ps(e);
  return t && (n || r == !1) ? js(t, e) : e;
}
const zt = (t) => t instanceof J ? { ...t } : t;
function se(t, e) {
  e = e || {};
  const r = {};
  function n(u, f, h, w) {
    return d.isPlainObject(u) && d.isPlainObject(f) ? d.merge.call({ caseless: w }, u, f) : d.isPlainObject(f) ? d.merge({}, f) : d.isArray(f) ? f.slice() : f;
  }
  function s(u, f, h, w) {
    if (d.isUndefined(f)) {
      if (!d.isUndefined(u))
        return n(void 0, u, h, w);
    } else
      return n(u, f, h, w);
  }
  function i(u, f) {
    if (!d.isUndefined(f))
      return n(void 0, f);
  }
  function o(u, f) {
    if (d.isUndefined(f)) {
      if (!d.isUndefined(u))
        return n(void 0, u);
    } else
      return n(void 0, f);
  }
  function c(u, f, h) {
    if (h in e)
      return n(u, f);
    if (h in t)
      return n(void 0, u);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: c,
    headers: (u, f, h) => s(zt(u), zt(f), h, !0)
  };
  return d.forEach(Object.keys({ ...t, ...e }), function(f) {
    const h = l[f] || s, w = h(t[f], e[f], f);
    d.isUndefined(w) && h !== c || (r[f] = w);
  }), r;
}
const Ar = (t) => {
  const e = se({}, t);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: c } = e;
  if (e.headers = o = J.from(o), e.url = br(Rr(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), c && o.set(
    "Authorization",
    "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : ""))
  ), d.isFormData(r)) {
    if (M.hasStandardBrowserEnv || M.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (d.isFunction(r.getHeaders)) {
      const l = r.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(l).forEach(([f, h]) => {
        u.includes(f.toLowerCase()) && o.set(f, h);
      });
    }
  }
  if (M.hasStandardBrowserEnv && (n && d.isFunction(n) && (n = n(e)), n || n !== !1 && Cs(e.url))) {
    const l = s && i && Fs.read(i);
    l && o.set(s, l);
  }
  return e;
}, xs = typeof XMLHttpRequest < "u", _s = xs && function(t) {
  return new Promise(function(r, n) {
    const s = Ar(t);
    let i = s.data;
    const o = J.from(s.headers).normalize();
    let { responseType: c, onUploadProgress: l, onDownloadProgress: u } = s, f, h, w, b, p;
    function g() {
      b && b(), p && p(), s.cancelToken && s.cancelToken.unsubscribe(f), s.signal && s.signal.removeEventListener("abort", f);
    }
    let y = new XMLHttpRequest();
    y.open(s.method.toUpperCase(), s.url, !0), y.timeout = s.timeout;
    function A() {
      if (!y)
        return;
      const I = J.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), q = {
        data: !c || c === "text" || c === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: I,
        config: t,
        request: y
      };
      Tr(function($) {
        r($), g();
      }, function($) {
        n($), g();
      }, q), y = null;
    }
    "onloadend" in y ? y.onloadend = A : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(A);
    }, y.onabort = function() {
      y && (n(new S("Request aborted", S.ECONNABORTED, t, y)), y = null);
    }, y.onerror = function(x) {
      const q = x && x.message ? x.message : "Network Error", Q = new S(q, S.ERR_NETWORK, t, y);
      Q.event = x || null, n(Q), y = null;
    }, y.ontimeout = function() {
      let x = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const q = s.transitional || vr;
      s.timeoutErrorMessage && (x = s.timeoutErrorMessage), n(new S(
        x,
        q.clarifyTimeoutError ? S.ETIMEDOUT : S.ECONNABORTED,
        t,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && d.forEach(o.toJSON(), function(x, q) {
      y.setRequestHeader(q, x);
    }), d.isUndefined(s.withCredentials) || (y.withCredentials = !!s.withCredentials), c && c !== "json" && (y.responseType = s.responseType), u && ([w, p] = De(u, !0), y.addEventListener("progress", w)), l && y.upload && ([h, b] = De(l), y.upload.addEventListener("progress", h), y.upload.addEventListener("loadend", b)), (s.cancelToken || s.signal) && (f = (I) => {
      y && (n(!I || I.type ? new he(null, t, y) : I), y.abort(), y = null);
    }, s.cancelToken && s.cancelToken.subscribe(f), s.signal && (s.signal.aborted ? f() : s.signal.addEventListener("abort", f)));
    const E = As(s.url);
    if (E && M.protocols.indexOf(E) === -1) {
      n(new S("Unsupported protocol " + E + ":", S.ERR_BAD_REQUEST, t));
      return;
    }
    y.send(i || null);
  });
}, Ms = (t, e) => {
  const { length: r } = t = t ? t.filter(Boolean) : [];
  if (e || r) {
    let n = new AbortController(), s;
    const i = function(u) {
      if (!s) {
        s = !0, c();
        const f = u instanceof Error ? u : this.reason;
        n.abort(f instanceof S ? f : new he(f instanceof Error ? f.message : f));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new S(`timeout ${e} of ms exceeded`, S.ETIMEDOUT));
    }, e);
    const c = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", i));
    const { signal: l } = n;
    return l.unsubscribe = () => d.asap(c), l;
  }
}, Ls = Ms, Ns = function* (t, e) {
  let r = t.byteLength;
  if (!e || r < e) {
    yield t;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + e, yield t.slice(n, s), n = s;
}, $s = async function* (t, e) {
  for await (const r of Ds(t))
    yield* Ns(r, e);
}, Ds = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await e.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await e.cancel();
  }
}, Jt = (t, e, r, n) => {
  const s = $s(t, e);
  let i = 0, o, c = (l) => {
    o || (o = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: f } = await s.next();
        if (u) {
          c(), l.close();
          return;
        }
        let h = f.byteLength;
        if (r) {
          let w = i += h;
          r(w);
        }
        l.enqueue(new Uint8Array(f));
      } catch (u) {
        throw c(u), u;
      }
    },
    cancel(l) {
      return c(l), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, Kt = 64 * 1024, { isFunction: xe } = d, Us = (({ Request: t, Response: e }) => ({
  Request: t,
  Response: e
}))(d.global), {
  ReadableStream: Yt,
  TextEncoder: Qt
} = d.global, Xt = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Bs = (t) => {
  t = d.merge.call({
    skipUndefined: !0
  }, Us, t);
  const { fetch: e, Request: r, Response: n } = t, s = e ? xe(e) : typeof fetch == "function", i = xe(r), o = xe(n);
  if (!s)
    return !1;
  const c = s && xe(Yt), l = s && (typeof Qt == "function" ? ((p) => (g) => p.encode(g))(new Qt()) : async (p) => new Uint8Array(await new r(p).arrayBuffer())), u = i && c && Xt(() => {
    let p = !1;
    const g = new r(M.origin, {
      body: new Yt(),
      method: "POST",
      get duplex() {
        return p = !0, "half";
      }
    }).headers.has("Content-Type");
    return p && !g;
  }), f = o && c && Xt(() => d.isReadableStream(new n("").body)), h = {
    stream: f && ((p) => p.body)
  };
  s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((p) => {
    !h[p] && (h[p] = (g, y) => {
      let A = g && g[p];
      if (A)
        return A.call(g);
      throw new S(`Response type '${p}' is not supported`, S.ERR_NOT_SUPPORT, y);
    });
  });
  const w = async (p) => {
    if (p == null)
      return 0;
    if (d.isBlob(p))
      return p.size;
    if (d.isSpecCompliantForm(p))
      return (await new r(M.origin, {
        method: "POST",
        body: p
      }).arrayBuffer()).byteLength;
    if (d.isArrayBufferView(p) || d.isArrayBuffer(p))
      return p.byteLength;
    if (d.isURLSearchParams(p) && (p = p + ""), d.isString(p))
      return (await l(p)).byteLength;
  }, b = async (p, g) => {
    const y = d.toFiniteNumber(p.getContentLength());
    return y ?? w(g);
  };
  return async (p) => {
    let {
      url: g,
      method: y,
      data: A,
      signal: E,
      cancelToken: I,
      timeout: x,
      onDownloadProgress: q,
      onUploadProgress: Q,
      responseType: $,
      headers: pe,
      withCredentials: ee = "same-origin",
      fetchOptions: Re
    } = Ar(p), Ae = e || fetch;
    $ = $ ? ($ + "").toLowerCase() : "text";
    let te = Ls([E, I && I.toAbortSignal()], x), _ = null;
    const L = te && te.unsubscribe && (() => {
      te.unsubscribe();
    });
    let Z;
    try {
      if (Q && u && y !== "get" && y !== "head" && (Z = await b(pe, A)) !== 0) {
        let z = new r(g, {
          method: "POST",
          body: A,
          duplex: "half"
        }), X;
        if (d.isFormData(A) && (X = z.headers.get("content-type")) && pe.setContentType(X), z.body) {
          const [ie, oe] = Ht(
            Z,
            De(Gt(Q))
          );
          A = Jt(z.body, Kt, ie, oe);
        }
      }
      d.isString(ee) || (ee = ee ? "include" : "omit");
      const W = i && "credentials" in r.prototype, me = {
        ...Re,
        signal: te,
        method: y.toUpperCase(),
        headers: pe.normalize().toJSON(),
        body: A,
        duplex: "half",
        credentials: W ? ee : void 0
      };
      _ = i && new r(g, me);
      let G = await (i ? Ae(_, Re) : Ae(g, me));
      const ge = f && ($ === "stream" || $ === "response");
      if (f && (q || ge && L)) {
        const z = {};
        ["status", "statusText", "headers"].forEach((Ie) => {
          z[Ie] = G[Ie];
        });
        const X = d.toFiniteNumber(G.headers.get("content-length")), [ie, oe] = q && Ht(
          X,
          De(Gt(q), !0)
        ) || [];
        G = new n(
          Jt(G.body, Kt, ie, () => {
            oe && oe(), L && L();
          }),
          z
        );
      }
      $ = $ || "text";
      let Oe = await h[d.findKey(h, $) || "text"](G, p);
      return !ge && L && L(), await new Promise((z, X) => {
        Tr(z, X, {
          data: Oe,
          headers: J.from(G.headers),
          status: G.status,
          statusText: G.statusText,
          config: p,
          request: _
        });
      });
    } catch (W) {
      throw L && L(), W && W.name === "TypeError" && /Load failed|fetch/i.test(W.message) ? Object.assign(
        new S("Network Error", S.ERR_NETWORK, p, _),
        {
          cause: W.cause || W
        }
      ) : S.from(W, W && W.code, p, _);
    }
  };
}, qs = /* @__PURE__ */ new Map(), Or = (t) => {
  let e = t && t.env || {};
  const { fetch: r, Request: n, Response: s } = e, i = [
    n,
    s,
    r
  ];
  let o = i.length, c = o, l, u, f = qs;
  for (; c--; )
    l = i[c], u = f.get(l), u === void 0 && f.set(l, u = c ? /* @__PURE__ */ new Map() : Bs(e)), f = u;
  return u;
};
Or();
const Tt = {
  http: ns,
  xhr: _s,
  fetch: {
    get: Or
  }
};
d.forEach(Tt, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Zt = (t) => `- ${t}`, Ws = (t) => d.isFunction(t) || t === null || t === !1;
function Vs(t, e) {
  t = d.isArray(t) ? t : [t];
  const { length: r } = t;
  let n, s;
  const i = {};
  for (let o = 0; o < r; o++) {
    n = t[o];
    let c;
    if (s = n, !Ws(n) && (s = Tt[(c = String(n)).toLowerCase()], s === void 0))
      throw new S(`Unknown adapter '${c}'`);
    if (s && (d.isFunction(s) || (s = s.get(e))))
      break;
    i[c || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(
      ([l, u]) => `adapter ${l} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let c = r ? o.length > 1 ? `since :
` + o.map(Zt).join(`
`) : " " + Zt(o[0]) : "as no adapter specified";
    throw new S(
      "There is no suitable adapter to dispatch the request " + c,
      "ERR_NOT_SUPPORT"
    );
  }
  return s;
}
const Ir = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: Vs,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Tt
};
function at(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new he(null, t);
}
function er(t) {
  return at(t), t.headers = J.from(t.headers), t.data = ot.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Ir.getAdapter(t.adapter || St.adapter, t)(t).then(function(n) {
    return at(t), n.data = ot.call(
      t,
      t.transformResponse,
      n
    ), n.headers = J.from(n.headers), n;
  }, function(n) {
    return Sr(n) || (at(t), n && n.response && (n.response.data = ot.call(
      t,
      t.transformResponse,
      n.response
    ), n.response.headers = J.from(n.response.headers))), Promise.reject(n);
  });
}
const Cr = "1.13.2", Ge = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Ge[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const tr = {};
Ge.transitional = function(e, r, n) {
  function s(i, o) {
    return "[Axios v" + Cr + "] Transitional option '" + i + "'" + o + (n ? ". " + n : "");
  }
  return (i, o, c) => {
    if (e === !1)
      throw new S(
        s(o, " has been removed" + (r ? " in " + r : "")),
        S.ERR_DEPRECATED
      );
    return r && !tr[o] && (tr[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(i, o, c) : !0;
  };
};
Ge.spelling = function(e) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function Hs(t, e, r) {
  if (typeof t != "object")
    throw new S("options must be an object", S.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(t);
  let s = n.length;
  for (; s-- > 0; ) {
    const i = n[s], o = e[i];
    if (o) {
      const c = t[i], l = c === void 0 || o(c, i, t);
      if (l !== !0)
        throw new S("option " + i + " must be " + l, S.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new S("Unknown option " + i, S.ERR_BAD_OPTION);
  }
}
const Le = {
  assertOptions: Hs,
  validators: Ge
}, Y = Le.validators;
class Ue {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Wt(),
      response: new Wt()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = se(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: i } = r;
    n !== void 0 && Le.assertOptions(n, {
      silentJSONParsing: Y.transitional(Y.boolean),
      forcedJSONParsing: Y.transitional(Y.boolean),
      clarifyTimeoutError: Y.transitional(Y.boolean)
    }, !1), s != null && (d.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : Le.assertOptions(s, {
      encode: Y.function,
      serialize: Y.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Le.assertOptions(r, {
      baseUrl: Y.spelling("baseURL"),
      withXsrfToken: Y.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let o = i && d.merge(
      i.common,
      i[r.method]
    );
    i && d.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), r.headers = J.concat(o, i);
    const c = [];
    let l = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(r) === !1 || (l = l && g.synchronous, c.unshift(g.fulfilled, g.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(g) {
      u.push(g.fulfilled, g.rejected);
    });
    let f, h = 0, w;
    if (!l) {
      const p = [er.bind(this), void 0];
      for (p.unshift(...c), p.push(...u), w = p.length, f = Promise.resolve(r); h < w; )
        f = f.then(p[h++], p[h++]);
      return f;
    }
    w = c.length;
    let b = r;
    for (; h < w; ) {
      const p = c[h++], g = c[h++];
      try {
        b = p(b);
      } catch (y) {
        g.call(this, y);
        break;
      }
    }
    try {
      f = er.call(this, b);
    } catch (p) {
      return Promise.reject(p);
    }
    for (h = 0, w = u.length; h < w; )
      f = f.then(u[h++], u[h++]);
    return f;
  }
  getUri(e) {
    e = se(this.defaults, e);
    const r = Rr(e.baseURL, e.url, e.allowAbsoluteUrls);
    return br(r, e.params, e.paramsSerializer);
  }
}
d.forEach(["delete", "get", "head", "options"], function(e) {
  Ue.prototype[e] = function(r, n) {
    return this.request(se(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
d.forEach(["post", "put", "patch"], function(e) {
  function r(n) {
    return function(i, o, c) {
      return this.request(se(c || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  Ue.prototype[e] = r(), Ue.prototype[e + "Form"] = r(!0);
});
const Ne = Ue;
class Rt {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners)
        return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((c) => {
        n.subscribe(c), i = c;
      }).then(s);
      return o.cancel = function() {
        n.unsubscribe(i);
      }, o;
    }, e(function(i, o, c) {
      n.reason || (n.reason = new he(i, o, c), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), r = (n) => {
      e.abort(n);
    };
    return this.subscribe(r), e.signal.unsubscribe = () => this.unsubscribe(r), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Rt(function(s) {
        e = s;
      }),
      cancel: e
    };
  }
}
const Gs = Rt;
function zs(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function Js(t) {
  return d.isObject(t) && t.isAxiosError === !0;
}
const gt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(gt).forEach(([t, e]) => {
  gt[e] = t;
});
const Ks = gt;
function Fr(t) {
  const e = new Ne(t), r = cr(Ne.prototype.request, e);
  return d.extend(r, Ne.prototype, e, { allOwnKeys: !0 }), d.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(s) {
    return Fr(se(t, s));
  }, r;
}
const j = Fr(St);
j.Axios = Ne;
j.CanceledError = he;
j.CancelToken = Gs;
j.isCancel = Sr;
j.VERSION = Cr;
j.toFormData = Ve;
j.AxiosError = S;
j.Cancel = j.CanceledError;
j.all = function(e) {
  return Promise.all(e);
};
j.spread = zs;
j.isAxiosError = Js;
j.mergeConfig = se;
j.AxiosHeaders = J;
j.formToJSON = (t) => Er(d.isHTMLForm(t) ? new FormData(t) : t);
j.getAdapter = Ir.getAdapter;
j.HttpStatusCode = Ks;
j.default = j;
const H = j, ct = 25833, Ys = (t) => t.domeneklasse !== "Matrikkeladresse", bi = (t) => ({
  knr: t.kommuneId,
  gnr: t.gardsnummer,
  bnr: t.bruksnummer,
  fnr: t.festenummer,
  snr: t.seksjonsnummer
}), yt = async (t, e, r, n, s) => {
  if (!r)
    return Promise.resolve(null);
  const i = `${t}/matrikkelenhet/${e}${n ? "/" + n : ""}`;
  try {
    return (await H.get(i, {
      params: { token: r, ...s }
    })).data;
  } catch {
    return Promise.reject("Feil med henting av matrikkelinformasjon. Prøv igjen.");
  }
}, Qs = (t) => {
  const e = (s) => s == null ? "" : String(s), r = t.undernummer == null ? "" : `-${e(t.undernummer)}`, n = `${e(t.nummer)}${r}${e(t.bokstav)}`;
  return `${e(t.adressenavn)} ${n}`.trim();
}, ue = (t) => {
  if (t == null || t === "")
    return;
  const e = Number(t);
  return Number.isFinite(e) ? e : void 0;
}, Pr = (t) => {
  const e = t?.adresser;
  if (!Array.isArray(e))
    return [];
  const r = [];
  for (const n of e) {
    if (!n || typeof n != "object")
      continue;
    const s = n, i = ue(s.adresseId);
    i !== void 0 && r.push({
      adresseId: i,
      domeneklasse: typeof s.domeneklasse == "string" ? s.domeneklasse : void 0,
      adressenavn: typeof s.adressenavn == "string" ? s.adressenavn : void 0,
      adressekode: s.adressekode == null ? void 0 : String(s.adressekode),
      nummer: ue(s.nummer),
      bokstav: typeof s.bokstav == "string" ? s.bokstav : void 0,
      undernummer: ue(s.undernummer),
      postnummer: s.postnummer == null ? void 0 : String(s.postnummer),
      postnavn: typeof s.postnavn == "string" ? s.postnavn : void 0,
      kommuneId: ue(s.kommuneId),
      x: ue(s.x),
      y: ue(s.y),
      tekst: Qs(s)
    });
  }
  return r;
}, Xs = (t) => Pr(t).map((e) => e.tekst).filter(Boolean), rr = async (t, e, r, n) => {
  if (!r)
    return [];
  const s = `${t}/matrikkelenhet/${e}/adresse`;
  try {
    const i = await H.get(s, { params: { token: r }, signal: n });
    return Pr(i.data);
  } catch (i) {
    if (H.isCancel(i))
      throw i;
    return console.warn(`[geoeiendom] kunne ikke hente adresser for matrikkelenhet ${e}`, i), [];
  }
}, vi = async (t, e, r) => {
  const n = `${t}/Matrikkelenhet/finn`, s = await ze(n, { geometry: e }, !1, r);
  if (!s?.matrikkelenheter)
    return [];
  const i = s.matrikkelenheter.map((l) => ({
    matrikkelenhetId: l.matrikkelenhetId,
    gardsnr: l.gardsnummer,
    bruksnr: l.bruksnummer,
    festenr: l.festenummer,
    seksjonsnr: l.seksjonsnummer,
    kommunenavn: l.kommunenavn,
    teigIds: l.teigIdsForGeometri ?? [],
    teigIdsForGeometri: l.teigIdsForGeometri ?? null,
    anleggsprojeksjonsflateIds: l.anleggsprosjeksjonsflateIdsForGeometri ?? [],
    seksjoner: []
  })), o = i.filter((l) => l.seksjonsnr === 0), c = i.filter((l) => l.seksjonsnr > 0);
  for (const l of c) {
    const u = o.find(
      (f) => f.gardsnr === l.gardsnr && f.bruksnr === l.bruksnr && f.festenr === l.festenr
    );
    u ? u.seksjoner.push(l) : o.push(l);
  }
  return o;
}, $e = async (t, e, r, n) => {
  if (e.length === 0)
    return [];
  const s = `${t}/Teig/geometri`, i = await ze(s, { teigIds: e, spatialReferenceWkid: r }, !1, n);
  return i?.teiger ? i.teiger.filter((o) => o.geometry).map((o) => ({ teigId: o.teigId, polygon: ft.fromJSON(o.geometry) })) : [];
}, Ei = async (t, e, r) => {
  const n = `${t}/Teig/matrikkelenhet`;
  return (await ze(n, { teigIds: [e] }, !1, r))?.matrikkelenhetIds?.[0];
}, Zs = 1e3, jr = async (t, e, r) => {
  const n = [];
  let s = null;
  try {
    for (let i = 0; i < Zs; i++) {
      const o = await yt(
        t,
        e,
        r,
        "teig",
        s ? { ContinuationToken: s } : void 0
      );
      if (n.push(...(o?.teiger ?? []).filter((c) => typeof c?.teigId == "number")), s = o?.nextContinuationToken ?? null, !s)
        break;
    }
  } catch (i) {
    console.warn(`[geoeiendom] henting av teiger for matrikkelenhet ${e} feilet etter ${n.length} hentet(e):`, i);
  }
  return n;
}, ei = async (t, e, r) => (await jr(t, e, r)).map((n) => n.teigId), Si = async (t, e, r) => jr(t, e, r), Ti = async (t, e, r, n) => {
  const s = await ei(t, e, n);
  if (s.length === 0)
    return { polygons: [], union: null };
  const o = (await $e(t, s, r, n)).map((l) => l.polygon);
  if (o.length === 0)
    return { polygons: [], union: null };
  const c = on.union(o);
  return { polygons: o, union: c };
}, Ri = (t, e, r) => {
  const n = `${t}/matrikkelenhet/${e}/rapport?token=${r}`;
  window.open(n);
}, Ai = (t, e, r) => {
  const n = `${t}/grunnbok/kartverket/rapport?kommunenummer=${e.knr}&gardsnummer=${e.gnr}&bruksnummer=${e.bnr}&festenummer=${e.fnr}&seksjonsnummer=${e.snr}&token=${r}`;
  window.open(n);
}, lt = async (t, e, r) => {
  const n = `${t}/Matrikkelenhet/finnvedgeometri`, i = await ze(n, { geometry: e }, !1, r);
  return i?.eiendommer ? (i.eiendommer.forEach((o) => o.teigIds = o.teigIdsForGeometri), i.eiendommer) : (console.warn(`[geoeiendom] finnvedgeometri ga ingen eiendommer (geometri-wkid=${e.spatialReference?.wkid})`), []);
}, Oi = async (t, e, r, n, s, i = 0, o = 0) => {
  if (!s)
    return Promise.reject("No token available");
  const c = `${t}/Matrikkelenhet/matrikkelenhetid`;
  try {
    return (await H.get(c, {
      params: {
        Kommunenummer: e,
        Gardsnummer: r,
        Bruksnummer: n,
        Festenummer: i,
        Seksjonsnummer: o,
        token: s
      }
    })).data.matrikkelenhetId;
  } catch {
    return Promise.reject("Failed to get matrikkelEnhetId");
  }
}, ze = async (t, e, r, n) => {
  if (!n)
    return Promise.resolve(null);
  const s = `${t}?Token=${n}`, i = r ? "blob" : "json", o = {
    "Content-Type": "application/json"
  };
  try {
    return (await H.post(s, e, { headers: o, responseType: i })).data;
  } catch (c) {
    const l = c?.response?.status;
    return console.warn(`[geoeiendom] POST feilet${l ? ` (HTTP ${l})` : ""}: '${t}'. ${c?.message ?? c}`), null;
  }
}, nr = {
  minRatio: 0.01,
  minAreaM2: 1 / 0
};
function ut(t) {
  try {
    return Math.abs(dn.execute(t, { unit: "square-meters" }));
  } catch {
    return 0;
  }
}
function ti(t, e, r = {}) {
  if (!t || !e)
    return { keep: !0, reason: "missing-geometry" };
  const n = r.minAreaM2 ?? nr.minAreaM2, s = r.minRatio ?? nr.minRatio, i = t.spatialReference?.wkid, o = e.spatialReference?.wkid;
  if (i != null && o != null && i !== o)
    return { keep: !0, reason: "sr-mismatch", srcWkid: i, candWkid: o };
  const c = t, l = e;
  try {
    if (!dt.execute(c, l))
      return { keep: !1, reason: "no-intersect", srcWkid: i, candWkid: o };
  } catch {
    return { keep: !0, reason: "intersect-error", srcWkid: i, candWkid: o };
  }
  let u;
  try {
    u = hn.execute(c, l);
  } catch {
    return { keep: !0, reason: "intersection-error", srcWkid: i, candWkid: o };
  }
  if (!u)
    return i != null && o != null && i === o ? { keep: !1, reason: "touch-no-area", srcWkid: i, candWkid: o, overlapAreaM2: 0, ratio: 0 } : { keep: !0, reason: "intersection-null", srcWkid: i, candWkid: o };
  const f = ut(u), h = ut(t), w = ut(e), b = Math.min(h, w), p = b > 0 ? f / b : 0, g = { srcWkid: i, candWkid: o, overlapAreaM2: f, sourceAreaM2: h, candidateAreaM2: w, ratio: p };
  return p >= s ? { keep: !0, reason: "ratio-pass", ...g } : f >= n ? { keep: !0, reason: "area-pass", ...g } : { keep: !1, reason: "below-threshold", ...g };
}
function ri(t, e, r = {}) {
  return ti(t, e, r).keep;
}
const sr = {
  perMatrikkelenhet: /* @__PURE__ */ new Map(),
  utenMatrikkelenhet: [],
  perAdresse: /* @__PURE__ */ new Map()
}, U = { add: "add", remove: "remove" };
async function ni(t, e, r) {
  const n = new Array(t.length);
  let s = 0;
  const i = Array.from({ length: Math.min(e, t.length) }, async () => {
    for (; s < t.length; ) {
      const o = s++;
      n[o] = await r(t[o]);
    }
  });
  return await Promise.all(i), n;
}
class Ii {
  constructor(e, r, n, s = "", i) {
    if (this.eiendomsLayerId = "Eiendommer", this.naboLayerId = "Naboer", this.activeOmradetype = "delomrade", this.savingCount = 0, this.avvikPort = i, this.mapView = e, this.token = r, this.apiUrl = n, this.eiendommerUrl = s, this.mapView.map) {
      if (!this.mapView.map.findLayerById(this.naboLayerId)) {
        const o = this.createClientSideFeatureLayer(e.spatialReference);
        o.blendMode = "normal", o.id = this.naboLayerId, o.popupEnabled = !1, this.mapView.map.add(o);
      }
      this.naboLayer = this.mapView.map.findLayerById(this.naboLayerId);
    }
    this.teiger = /* @__PURE__ */ new Map(), this.baselineEnheter = /* @__PURE__ */ new Map(), this.baselineAdresser = /* @__PURE__ */ new Map(), this.fjernedeAdresseIds = /* @__PURE__ */ new Set(), this.persistedAddedMatrikkelenhetIds = /* @__PURE__ */ new Set(), this.activeOmradeId = void 0;
  }
  async getIntersectingProperties(e, r, n) {
    await this.resetSelectionState(), console.log("Getting parts liste for graphics:", e);
    const s = e.map(async (p) => p.geometry ? lt(n, p.geometry, r) : Promise.resolve(void 0)), i = await Promise.allSettled(s), o = this.getMatrikkelEnhetIds(i), c = this.getOmradeIds(e);
    this.activeOmradeId = c.at(0), this.activeOmradetype = this.getOmradetype(e);
    const l = this.avvikPort && o.length > 0 && c.length > 0 ? await this.avvikPort.hentDeltaerForOmråder(c, this.activeOmradetype) : sr;
    this.persistedAddedMatrikkelenhetIds = this.getPersistedAddedMatrikkelenhetIds(l);
    const u = new Set(o), f = await this.fetchAddedMatrikkelenheterOutsideIntersecting(
      u,
      l
    ), { keepTeigIds: h, teigGeometryById: w } = await this.computeOverlappingTeiger(
      i,
      e
    );
    i.forEach((p) => {
      if (p.status === "fulfilled" && p.value) {
        for (const g of p.value)
          if (g.gardsnr !== 0) {
            if (h) {
              g.teigIds = (g.teigIds ?? []).filter((y) => h.has(y));
              for (const y of g.seksjoner ?? [])
                y.teigIds = (y.teigIds ?? []).filter((A) => h.has(A));
            }
            this.registrerBaseline(g), this.avvikPort?.anvendPåEnhetstre(g, l, "merge"), this.setTeiger(g, !1), this.setTeiger(g.seksjoner, !1);
          }
      }
      p.status === "rejected" && console.log(`Error query matrikkelenhet from geometry, ${p.reason}`);
    });
    for (const p of f)
      p.gardsnr !== 0 && (this.avvikPort?.anvendPåEnhetstre(p, l, "kun-tillagte"), this.registrerBaseline(p), this.setTeiger(p, !1), this.setTeiger(p.seksjoner, !1));
    await this.hentAdresserForEnheterUtenAdresse(), this.lesFjernedeAdresser(l), await this.addMatrikkelEnheterToMap([...this.teiger.keys()], "nabo", w), this.emitState();
    const b = e[0]?.geometry;
    if (b) {
      const p = b.type ? b : ft.fromJSON(b);
      await this.mapView.goTo(p), this.flashGeometry(p);
    }
  }
  /**
   * Registrer hovedeiendommen OG hver seksjon i baselinen med teig-lista si slik
   * den er NÅ (etter geometri-beskjæring, før deltaer). Ett nivå dypt, samme
   * dybde som `anvendDeltaerPåEnhetstre`.
   *
   * Enheter uten teiger i baselinen registreres ikke: de ligger utenfor
   * områdegeometrien, og en «fjernet»-oppføring for dem ville vært meningsløs
   * (det finnes ikke noe å reversere til).
   */
  registrerBaseline(e) {
    this.registrerBaselineNode(e);
    for (const r of e.seksjoner ?? [])
      this.registrerBaselineNode(r);
  }
  /**
   * Registrer ÉN node. Utskilt fra `registrerBaseline` fordi kartklikk-veien
   * registrerer node for node: der er hver enhet på den klikkede teigen sin egen
   * oppføring, og en `seksjoner`-gjennomgang ville registrert søsken som IKKE ble
   * lagt til (de kan være filtrert bort av `setTeiger`). De ville da dukket opp
   * som nedtonede «fjernet»-chips uten at noen har fjernet dem —
   * `beregnFjernedeEnheter` er baseline MINUS aktive.
   */
  registrerBaselineNode(e) {
    const r = [...e.teigIds ?? []];
    r.length !== 0 && (this.baselineEnheter.set(e.matrikkelenhetId, { enhet: e, teigIds: r }), this.registrerBaselineAdresser(e));
  }
  /**
   * Registrer kun ADRESSE-sporet for en enhet.
   *
   * Adresser som alt ligger på enheten registreres med én gang; de som må
   * etterhentes kommer inn via `hentAdresserFor` (13928).
   *
   * Utskilt fordi egendefinerte områder trenger dette UTEN en
   * `baselineEnheter`-oppføring: der sletter en fjerning selve add-raden, så
   * enhets-sporet har ingen baseline å reversere til — og skal ikke få én, for da
   * ville enheter som forsvinner blitt stående som nedtonede «fjernet»-chips. Men
   * «×» på en ADRESSE-chip krever oppslag i `baselineAdresser`, ellers no-op-er
   * `skrivAdresseAvvik` stille og knappen blir død.
   */
  registrerBaselineAdresser(e) {
    for (const r of e.adresser ?? [])
      this.baselineAdresser.set(r.adresseId, { adresse: r, enhet: e });
  }
  /**
   * Hent adresselister for enhetene i baselinen som IKKE fikk adresse fra
   * `finnvedgeometri` (13928). Tom `adresse` er signalet tjenesten gir for
   * enheter med flere adresser — typisk boligbyggerlag. Antall ekstra kall blir
   * dermed proporsjonalt med antall slike enheter, ikke med planens størrelse.
   *
   * SEKSJONERTE enheter er unntatt. Det er ikke en optimalisering, det er en
   * semantisk grense: adresse-sporet finnes for USEKSJONERTE andeler, som ikke
   * har noen matrikkelenhet å bli fjernet gjennom. En seksjonert grunneiendom
   * har også tom `adresse`, og `/matrikkelenhet/{id}/adresse` svarer da med
   * seksjonenes vegadresser — adresser som allerede er representert av
   * seksjonene selv. Uten unntaket blir hver slik adresse TO chips med
   * motstridende «×»: én på adresse-sporet (som lar seksjonen stå i utvalget og
   * skriver en rad publikum kan forkaste) og én på enhets-sporet.
   *
   * Grensen holder også når seksjonene er beskåret bort av områdegeometrien: da
   * er de bevisst usynlige (`registrerBaseline` utelater noder uten teiger, og
   * `setTeiger` gjør ingenting for dem), og forelderens adresseliste ville
   * GJENINNFØRT andeler som ligger utenfor området.
   *
   * Fail-open per enhet: `getAdresserForMatrikkelenhet` svelger feil og gir tom
   * liste, så én utilgjengelig enhet feller ikke lasten av et helt planområde.
   * Enheten vises da med `gnr/bnr`-etiketten som før.
   */
  async hentAdresserForEnheterUtenAdresse() {
    await this.hentAdresserFor([...this.baselineEnheter.values()].map(({ enhet: e }) => e));
  }
  /**
   * Etterhent adresselister for de av `enheter` som mangler adresse. Se
   * docblocken på `hentAdresserForEnheterUtenAdresse` for hvorfor tom `adresse`
   * er signalet, og hvorfor seksjonerte enheter er unntatt.
   *
   * KALLER-KONTRAKT: `enheter` må være enhetene slik geoeiendom ga dem, ikke
   * projeksjoner av dem. Vaktposten under kan bare se `enhet.seksjoner`, så en
   * `{...enhet, seksjoner: []}`-kopi (kartklikk, teig-nivå) ville sluppet gjennom
   * som useksjonert og fått seksjonenes adresser — nøyaktig dobbeltvisningen
   * unntaket finnes for å hindre. Kallere som projiserer MÅ filtrere mot
   * originalen først; se `berikKlikkedeEnheter`.
   */
  async hentAdresserFor(e) {
    const r = e.filter(
      (n) => !n.adresse && !n.adresser && !n.seksjoner?.length
    );
    r.length !== 0 && await ni(r, 6, async (n) => {
      const s = await rr(
        this.apiUrl,
        n.matrikkelenhetId,
        this.token
      );
      if (s.length !== 0) {
        n.adresser = s;
        for (const i of s)
          this.baselineAdresser.set(i.adresseId, { adresse: i, enhet: n });
      }
    });
  }
  /**
   * Les hvilke adresser som er fjernet, fra `perAdresse`-bøtta. Sekvensiell
   * anvendelse (siste rad vinner) — samme defensive form som teig-anvendelsen;
   * på data som følger invarianten finnes det maks én rad per relasjon.
   */
  lesFjernedeAdresser(e) {
    this.fjernedeAdresseIds.clear();
    for (const [r, n] of e.perAdresse) {
      let s = !1;
      for (const i of n)
        s = i.operation === U.remove;
      s && this.fjernedeAdresseIds.add(r);
    }
  }
  async resetSelectionState() {
    this.teiger.clear(), this.baselineEnheter.clear(), this.baselineAdresser.clear(), this.fjernedeAdresseIds.clear(), this.persistedAddedMatrikkelenhetIds.clear(), this.activeOmradeId = void 0, this.activeOmradetype = "delomrade";
    const e = await this.naboLayer.queryFeatures();
    e.features.length > 0 && await this.naboLayer.applyEdits({
      deleteFeatures: e.features
    });
  }
  getMatrikkelEnhetIds(e) {
    return e.map((n) => {
      if (!(n.status !== "fulfilled" || !n.value)) {
        for (const s of n.value)
          if (s.gardsnr !== 0)
            return s.matrikkelenhetId;
      }
    }).filter((n) => n !== void 0);
  }
  /**
   * Registrer callbacken som får hele tilstanden hver gang noe endres. Erstatter
   * det gamle globale window-eventet (ba307e0): emitter og mottaker tilhører
   * samme effekt-kjøring, så lista kan ikke desynce ved rekonstruksjon.
   *
   * Kall med `undefined` for å melde av — gjøres i effektens opprydding.
   * Se `EiendomsvelgerState`.
   */
  setOnChange(e) {
    this.onChange = e;
  }
  /**
   * Kjør en lagre-operasjon med save-indikator. Teller nøstede/parallelle
   * lagringer så indikatoren først slås av når ALT er ferdig.
   */
  async runSaving(e) {
    this.savingCount++, this.savingCount === 1 && this.emitState();
    try {
      return await e();
    } finally {
      this.savingCount--, this.savingCount === 0 && this.emitState();
    }
  }
  async activatePropertySelector() {
    this.hitTestHandle || (this.hitTestHandle = this.mapView.on("click", (e) => this.handleClickEvent(e, this.mapView)));
  }
  deactivatePropertySelector() {
    this.hitTestHandle?.remove();
  }
  async clearSelection() {
    await this.resetSelectionState(), this.emitState();
  }
  /**
   * Load parcels purely from persisted "add" deltas (no spatial intersect).
   * Used for egendefinerte områder that have no geometry of their own.
   */
  async loadPersistedProperties(e, r = "egendefinert") {
    await this.resetSelectionState();
    const n = String(e);
    this.activeOmradeId = n, this.activeOmradetype = r;
    const s = this.avvikPort ? await this.avvikPort.hentDeltaerForOmråde(n, r) : sr, i = await this.fetchAddedMatrikkelenheterOutsideIntersecting(
      /* @__PURE__ */ new Set(),
      s,
      !0
      // skip finnVedGeometri — deltas already carry matrikkelenhetId
    );
    for (const o of i)
      if (o.gardsnr !== 0) {
        this.avvikPort?.anvendPåEnhetstre(o, s, "kun-tillagte"), this.registrerBaselineAdresser(o);
        for (const c of o.seksjoner ?? [])
          this.registrerBaselineAdresser(c);
        this.setTeiger(o, !1), this.setTeiger(o.seksjoner, !1);
      }
    this.lesFjernedeAdresser(s), await this.paintPersistedAddedDeltas(s), this.emitState();
  }
  /**
   * Paint polygons directly from the geometry stored on each add-delta in
   * eiendommer_v7. Used by loadPersistedProperties because legacy imports
   * lack teigId, so the teigId→geoeiendom refetch path returns nothing.
   */
  async paintPersistedAddedDeltas(e) {
    const r = this.mapView?.spatialReference, n = [], s = [], i = [...e.perMatrikkelenhet.values(), e.utenMatrikkelenhet];
    for (const o of i)
      for (const c of o) {
        if (c.operation !== U.add || !c.geometry)
          continue;
        const l = c.teigId ?? (c.deltaObjectId != null ? -c.deltaObjectId : void 0);
        if (l === void 0)
          continue;
        const u = c.geometry;
        r && (u.spatialReference = r), n.push(new st({
          geometry: u,
          attributes: { id: l, gids: String(l), type: "nabo" }
        })), s.push(u);
      }
    n.length !== 0 && (await this.naboLayer.applyEdits({ addFeatures: n }), this.mapView && s.length > 0 && await this.mapView.goTo(s, { duration: 400 }));
  }
  /**
   * Delete all eiendommer_v4 records for a given område.
   * Used for cleanup when an egendefinert område is deleted.
   */
  async deleteAllDeltasForOmrade(e, r) {
    if (this.avvikPort)
      try {
        await this.avvikPort.slettAlleForOmråde(String(e), r);
      } catch (n) {
        console.error("Failed to delete all deltas for område", e, n);
      }
  }
  gotoEiendom(e) {
    const r = e.teigIds;
    r && this.mapView.when(() => {
      const n = this.naboLayer.createQuery();
      n.where = this.constructWhereClause(r, "id"), this.naboLayer.queryFeatures(n).then((s) => {
        this.mapView.goTo(s.features);
      });
    });
  }
  async removeMatrikkelEnheter(e) {
    await this.runSaving(() => this.removeMatrikkelEnheterInner(e));
  }
  async removeMatrikkelEnheterInner(e) {
    const r = e.flatMap((u) => u.teigIds ?? []);
    if (r.length === 0)
      return;
    const n = this.naboLayer.createQuery();
    n.where = this.constructWhereClause(r, "id");
    const i = (await this.naboLayer.queryFeatures(n)).features, o = e.flatMap(
      (u) => (u.teigIds ?? []).flatMap((f) => {
        const h = i.find((w) => w.attributes.id === f);
        return h ? [{
          id: f,
          matrikkelenhetId: u.matrikkelenhetId,
          geometry: h.geometry
        }] : [];
      })
    );
    await this.addTeigDeltaToService(o, U.remove);
    const c = new Set(e.map((u) => u.matrikkelenhetId)), l = [];
    for (const u of new Set(r)) {
      const f = (this.teiger.get(u) ?? []).filter((h) => !c.has(h.matrikkelenhetId));
      f.length === 0 ? (this.teiger.delete(u), l.push(u)) : this.teiger.set(u, f);
    }
    if (l.length > 0) {
      const u = new Set(l);
      await this.deleteGraphics(i.filter((f) => u.has(f.attributes.id)));
    }
    this.emitState();
  }
  /**
   * Invers av removeMatrikkelEnheter — legger matrikkelenhetene tilbake:
   * re-maler teigene, persisterer en «add»-delta som overstyrer den forrige
   * «remove»-deltaen, og gjenoppretter teiger-mappen. Brukes av angre-toasten
   * når saksbehandleren fjernet noe ved et uhell. Speiler add-grenen i
   * handleClickEvent (matrikkelenhet-nivå).
   */
  async addMatrikkelEnheter(e) {
    await this.runSaving(() => this.addMatrikkelEnheterInner(e));
  }
  /**
   * Legg tilbake enheter saksbehandleren har fjernet (task 13927) — én adresse
   * om gangen, uten å dra med søsknene på samme teig.
   *
   * Enheten hydreres med `baselineTeigIds` fordi den delta-anvendte `teigIds` er
   * tom (det er nettopp derfor den forsvant fra lista). `seksjoner: []` er
   * kritisk: `addMatrikkelEnheterInner` registrerer ellers seksjonene til
   * enheten også, og da ville en gjenoppretting trukket tilbake søsken som er
   * bevisst fjernet — nøyaktig feilen kartklikk-veien har.
   *
   * Persisteringen er allerede riktig: `settAvvik('add')` sletter `remove`-raden
   * og skriver INGEN ny rad, altså tilbake til geometri-default. Alle
   * baseline-teigene til en helt fjernet enhet har en `remove`-rad, så det
   * opprettes ingen overflødige `add`-rader.
   */
  async gjenopprettEnheter(e) {
    const r = [];
    for (const n of new Set(e)) {
      const s = this.baselineEnheter.get(n);
      if (!s) {
        console.warn(`Ingen baseline for matrikkelenhet ${n} — kan ikke gjenopprette.`);
        continue;
      }
      r.push({ ...s.enhet, teigIds: [...s.teigIds], seksjoner: [] });
    }
    r.length !== 0 && await this.runSaving(() => this.addMatrikkelEnheterInner(r));
  }
  /**
   * Fjern enkeltadresser fra utvalget (task 13928).
   *
   * Skriver én rad per adresse, nøklet på
   * (teigId, matrikkelenhetId, omradeid, omradetype, adresseId). Rører
   * BEVISST ikke `this.teiger` og maler/avmaler ingenting: teigen tilhører
   * matrikkelenheten, som fortsatt er i utvalget fordi de andre adressene på
   * den er der. Det er hele grunnen til at adresse-avvik er et eget spor.
   */
  /**
   * Zoom til en adresses egen koordinat (13928, AK5). Løser at en FJERNET
   * adresse ikke har noen teig å zoome til.
   *
   * Koordinaten er i EUREF89 UTM33 (`GEOEIENDOM_ADRESSE_WKID`) uansett hvor i
   * landet eiendommen ligger, og må projiseres til kartets SR. Tolket direkte i
   * kartets SR ville et Østfold-punkt landet flere hundre kilometer feil.
   *
   * Etter projisering sanity-sjekkes punktet mot enhetens teiger; treffer det
   * ikke, gjøres INGENTING (fail-open). Bedre ingen zoom enn en zoom til havet.
   */
  async gotoAdresse(e) {
    if (e.x == null || e.y == null)
      return;
    const r = this.mapView?.spatialReference;
    if (!r)
      return;
    const n = new un({
      x: e.x,
      y: e.y,
      spatialReference: new fn({ wkid: ct })
    });
    let s = n;
    if (r.wkid !== ct) {
      if (!le.isLoaded())
        try {
          await le.load();
        } catch (c) {
          console.warn("[NaboListeService] kunne ikke laste projectOperator — hopper over zoom", c);
          return;
        }
      try {
        s = le.execute(n, r) ?? n;
      } catch (c) {
        console.warn("[NaboListeService] kunne ikke projisere adressekoordinat — hopper over zoom", c);
        return;
      }
    }
    const i = this.baselineAdresser.get(e.adresseId)?.enhet, o = i ? this.baselineEnheter.get(i.matrikkelenhetId)?.teigIds ?? i.teigIds ?? [] : [];
    if (o.length > 0) {
      const c = this.naboLayer.createQuery();
      if (c.where = this.constructWhereClause(o, "id"), !(await this.naboLayer.queryFeatures(c)).features.some(
        (f) => f.geometry ? dt.execute(s, f.geometry) : !1
      )) {
        console.warn(
          `[NaboListeService] adresse ${e.adresseId} (${e.tekst}) faller utenfor eiendommens teiger etter projisering ${ct}→${r.wkid} — hopper over zoom.`
        );
        return;
      }
    }
    await this.mapView.goTo({ target: s, scale: 2e3 });
  }
  async fjernAdresser(e) {
    await this.skrivAdresseAvvik(e, U.remove);
  }
  /**
   * Legg tilbake fjernede enkeltadresser. `settAvvik('add')` sletter
   * `remove`-raden og skriver INGEN ny — tilbake til geometri-default.
   */
  async gjenopprettAdresser(e) {
    await this.skrivAdresseAvvik(e, U.add);
  }
  async skrivAdresseAvvik(e, r) {
    const n = [...new Set(e)].map((s) => ({ adresseId: s, treff: this.baselineAdresser.get(s) })).filter((s) => s.treff ? !0 : (console.warn(`Ingen baseline for adresse ${s.adresseId} — hopper over ${r}.`), !1));
    n.length !== 0 && (await this.runSaving(async () => {
      for (const { adresseId: s, treff: i } of n) {
        const o = this.baselineEnheter.get(i.enhet.matrikkelenhetId)?.teigIds ?? i.enhet.teigIds ?? [], c = [];
        for (const l of o) {
          const u = await this.hentTeigGeometri(l);
          u && c.push({ id: l, matrikkelenhetId: i.enhet.matrikkelenhetId, geometry: u });
        }
        await this.addTeigDeltaToService(c, r, s), r === U.remove ? this.fjernedeAdresseIds.add(s) : this.fjernedeAdresseIds.delete(s);
      }
    }), this.emitState());
  }
  /** Teig-geometri fra naboLayer, med geoeiendom som reserve. */
  async hentTeigGeometri(e) {
    const r = this.naboLayer.createQuery();
    r.where = this.constructWhereClause([e], "id");
    const s = (await this.naboLayer.queryFeatures(r)).features.find((c) => c.attributes.id === e);
    if (s?.geometry)
      return s.geometry;
    const i = this.mapView?.spatialReference?.wkid;
    return i == null ? void 0 : (await $e(this.apiUrl, [e], i, this.token)).find((c) => c.teigId === e)?.polygon;
  }
  async addMatrikkelEnheterInner(e) {
    const r = [...new Set(e.flatMap((h) => h.teigIds ?? []))];
    if (r.length === 0)
      return;
    const n = this.naboLayer.createQuery();
    n.where = this.constructWhereClause(r, "id");
    const s = await this.naboLayer.queryFeatures(n), i = new Set(s.features.map((h) => h.attributes.id)), o = r.filter((h) => !i.has(h));
    o.length > 0 && await this.addMatrikkelEnheterToMap(o, "nabo");
    const c = this.naboLayer.createQuery();
    c.where = this.constructWhereClause(r, "id");
    const l = await this.naboLayer.queryFeatures(c), u = new Map(
      l.features.map((h) => [h.attributes.id, h.geometry])
    ), f = [];
    for (const h of e) {
      this.setTeiger(h, !1), this.setTeiger(h?.seksjoner, !0, h.teigIds);
      for (const w of h.teigIds ?? []) {
        const b = u.get(w);
        b && f.push({
          id: w,
          matrikkelenhetId: h.matrikkelenhetId,
          geometry: b
        });
      }
    }
    await this.addTeigDeltaToService(f, U.add), this.emitState();
  }
  /**
   * Gi enhetene et kartklikk nettopp la til adresselistene sine (13928).
   *
   * `finnvedgeometri` svarer med `adresse?: string` og ALDRI med `adresser[]`, så
   * uten dette faller en gjen-lagt eiendom med flere vegadresser tilbake til én
   * `gnr/bnr`-chip. Chip-«+»-veien (`gjenopprettEnheter`) virket fordi den
   * hydrerer fra baseline-OBJEKTET — det samme objektet adressehentingen muterte
   * — mens kartklikk bygger ferske objekter. Det er hele asymmetrien.
   *
   * To tilfeller:
   *  - I BASELINEN: gjenbruk baselinens adresse-objekter. Ingen nettverkskall, og
   *    — viktigere — IDENTISKE `adresseId`-er. Fjernet-adresse-radene er nøklet på
   *    adresseId (`skrivAdresseAvvik`, `beregnFjernedeAdresser`), så en enhet som
   *    kom tilbake med ferske adresse-objekter ville mistet koblingen til søsken
   *    som står fjernet. Delt referanse er dessuten ØNSKET: de to objektene for
   *    samme matrikkelenhet holdes da ENIGE, og divergensen (kopi A med
   *    `adresser[]`, kopi B med bare en `adresse`-streng) er nettopp
   *    spor-kollisjonen `advarOmSporkollisjoner` varsler om på UI-siden.
   *  - UTENFOR BASELINEN (klikket utenfor områdegeometrien): registrer en baseline
   *    NÅ og hent adressene. Uten baselinen har «Angre»/«+» ingenting å legge
   *    tilbake til — `gjenopprettEnheter` logger «Ingen baseline …» og gjør
   *    ingenting — og adressene havner ikke i `baselineAdresser`, så «×» på en
   *    adresse-chip blir en stille no-op.
   *
   * Vi RE-HENTER aldri for en baseline-enhet som står uten adresser: lasten har
   * alt forsøkt, og dens fail-open-utfall er sannheten for økten. Ellers ville en
   * treg eller nede adresse-tjeneste kostet et kall per kartklikk.
   */
  async berikKlikkedeEnheter(e) {
    if (e.length === 0)
      return;
    const r = [];
    for (const { visning: n, original: s } of e) {
      const i = this.baselineEnheter.get(n.matrikkelenhetId);
      if (i) {
        i.enhet.adresser?.length ? n.adresser = i.enhet.adresser : !n.adresse && i.enhet.adresse && (n.adresse = i.enhet.adresse);
        continue;
      }
      this.registrerBaselineNode(n), r.push({ visning: n, original: s });
    }
    await this.hentAdresserFor(
      r.filter(({ original: n }) => !n.seksjoner?.length).map(({ visning: n }) => n)
    );
    for (const { visning: n } of r)
      this.registrerBaselineAdresser(n);
  }
  async handleClickEvent(e, r) {
    await this.runSaving(() => this.handleClickEventInner(e, r));
  }
  async handleClickEventInner(e, r) {
    const n = e.mapPoint, s = await r.hitTest(e);
    if (this.isHovedEiendom(s.results))
      return;
    const i = [];
    let o = await this.getNaboerFromHitResults(s.results);
    if (o = o.filter((c) => dt.execute(n, c.geometry)), o.length > 0)
      if (!!e.native?.shiftKey) {
        const l = o[0].attributes.id, u = this.teiger.get(l) ?? [], f = [...new Set(u.flatMap((g) => g.teigIds ?? []))], h = this.naboLayer.createQuery();
        h.where = this.constructWhereClause(f, "id");
        const w = await this.naboLayer.queryFeatures(h);
        await this.deleteGraphics(w.features);
        const b = new Map(
          w.features.map((g) => [g.attributes.id, g.geometry])
        ), p = u.flatMap(
          (g) => (g.teigIds ?? []).map((y) => ({
            id: y,
            matrikkelenhetId: g.matrikkelenhetId,
            geometry: b.get(y) ?? o[0].geometry
          }))
        );
        await this.addTeigDeltaToService(p, U.remove), f.forEach((g) => this.teiger.delete(g));
      } else {
        const l = o.map((f) => f.attributes.id);
        await this.deleteGraphics(o);
        const u = l.flatMap((f) => this.teiger.get(f)?.map((w) => ({
          id: f,
          matrikkelenhetId: w.matrikkelenhetId,
          geometry: o.find((b) => b.attributes.id === f)?.geometry
        })) ?? []);
        await this.addTeigDeltaToService(u, U.remove), l.forEach((f) => this.teiger.delete(f));
      }
    else {
      const c = !!e.native?.shiftKey, l = await lt(this.apiUrl, n, this.token);
      if (l.length === 0)
        return;
      if (c) {
        const u = [...new Set(l.flatMap((E) => E.teigIds ?? []))], f = this.naboLayer.createQuery();
        f.where = this.constructWhereClause(u, "id");
        const h = await this.naboLayer.queryFeatures(f), w = new Set(h.features.map((E) => E.attributes.id)), b = u.filter((E) => !w.has(E));
        b.length > 0 && await this.addMatrikkelEnheterToMap(b, "nabo");
        const p = this.naboLayer.createQuery();
        p.where = this.constructWhereClause(u, "id");
        const g = await this.naboLayer.queryFeatures(p), y = new Map(
          g.features.map((E) => [E.attributes.id, E.geometry])
        ), A = [];
        for (const E of l) {
          for (const I of this.setTeiger(E, !1))
            i.push({ visning: I, original: E });
          for (const I of this.setTeiger(E?.seksjoner, !0, E.teigIds))
            i.push({ visning: I, original: I });
          for (const I of E.teigIds ?? []) {
            const x = y.get(I);
            x && A.push({
              id: I,
              matrikkelenhetId: E.matrikkelenhetId,
              geometry: x
            });
          }
        }
        await this.addTeigDeltaToService(A, U.add);
      } else {
        const u = await this.getNabokandidaterFromHitResults(s.results);
        if (u.length === 0)
          return;
        await this.addGraphics(u, "nabo");
        const f = u[0].attributes.id, h = u[0].geometry, w = [];
        for (const b of l) {
          if (!(b.teigIds ?? []).includes(f))
            continue;
          const p = [b, ...b.seksjoner ?? []];
          for (const g of p) {
            const y = { ...g, teigIds: [f], seksjoner: [] };
            for (const A of this.setTeiger(y, !1))
              i.push({ visning: A, original: g });
            w.push({
              id: f,
              matrikkelenhetId: g.matrikkelenhetId,
              geometry: h
            });
          }
        }
        await this.addTeigDeltaToService(w, U.add);
      }
    }
    await this.berikKlikkedeEnheter(i), this.emitState();
  }
  /**
   * Idempotent, tilstandsbasert skriving mot eiendommer_v7. En delta er et AVVIK
   * fra den geometriske baselinen (hva delområdet/planen selv overlapper):
   *   - fjerning av en enhet INNENFOR geometrien  → `remove`
   *   - tillegg av en enhet UTENFOR geometrien     → `add`
   *   - «tilbake til default»                        → INGEN rad (fravær = følg geometri)
   *
   * For hver relasjon (teigId, matrikkelenhetId, omradeid, omradetype) spørres
   * tjenesten om eksisterende rad(er):
   *   - samme operasjon finnes allerede → no-op (rydd evt. duplikater)
   *   - MOTSATT operasjon finnes         → slett den, skriv INGEN ny (default igjen)
   *   - ingen rad                        → skriv den nye (ekte avvik)
   *
   * Resultatet er at tabellen kun inneholder ekte avvik, maks én rad per relasjon,
   * uavhengig av økt-state. «Motsatt finnes»-grenen utnytter at eksistensen av en
   * motsatt rad impliserer enhetens baseline, så vi trenger ikke kjenne geometrien
   * her.
   */
  async addTeigDeltaToService(e, r, n) {
    const s = e.filter((i) => i !== void 0);
    if (s.length !== 0) {
      if (!this.avvikPort) {
        console.warn(`avvikPort er ikke injisert. Hopper over ${r} delta-skriving.`);
        return;
      }
      if (this.activeOmradeId == null || String(this.activeOmradeId).trim() === "") {
        console.warn(`activeOmradeId mangler — hopper over ${r} delta-skriving (unngår rad uten omradeid).`);
        return;
      }
      for (const i of s)
        await this.avvikPort.settAvvik({
          teigId: i.id,
          matrikkelenhetId: i.matrikkelenhetId,
          omradeId: this.activeOmradeId,
          omradetype: this.activeOmradetype,
          operation: r,
          geometry: i.geometry,
          adresseId: n
        });
    }
  }
  async fetchAddedMatrikkelenheterOutsideIntersecting(e, r, n = !1) {
    const s = [...r.perMatrikkelenhet.entries()].filter(
      ([c, l]) => !e.has(c) && l.some((u) => u.operation === U.add)
    ).map(([c]) => c);
    if (s.length === 0)
      return [];
    const i = s.map(async (c) => {
      try {
        if (!n) {
          const h = (r.perMatrikkelenhet.get(c) ?? []).filter(
            (w) => w.operation === U.add && w.geometry
          );
          for (const w of h) {
            const b = [];
            w.geometry?.extent?.center && b.push(w.geometry.extent.center), w.geometry && b.push(w.geometry);
            let p;
            for (const g of b) {
              const y = await lt(this.apiUrl, g, this.token);
              if (!(!Array.isArray(y) || y.length === 0) && (p = this.findMatrikkelenhetById(y, c), p))
                break;
            }
            if (p)
              return await this.enrichAdresseIfMissing(p, c), p;
          }
        }
        const l = await yt(this.apiUrl, c, this.token), u = this.normalizeMatrikkelEnhetFromQueryResponse(l, c);
        if (u)
          return await this.enrichAdresseIfMissing(u, c), u;
      } catch (l) {
        console.error(`Failed to fetch matrikkelenhet ${c} from geoeiendom`, l);
      }
    });
    return (await Promise.all(i)).filter((c) => c !== void 0);
  }
  normalizeMatrikkelEnhetFromQueryResponse(e, r) {
    if (e) {
      if (typeof e == "object" && e.matrikkelenhetId === r)
        return e;
      if (Array.isArray(e))
        return e.find((n) => n?.matrikkelenhetId === r);
      if (Array.isArray(e.eiendommer))
        return e.eiendommer.find((n) => n?.matrikkelenhetId === r);
    }
  }
  /**
   * Gi en enhet lagt til UTENFOR områdegeometrien adressen sin.
   *
   * Hele adresselista hentes først, ikke bare en enkeltstreng: en enhet med flere
   * vegadresser (boligbyggerlag) skal fan-e ut til én chip per andel, og det
   * krever `adresser[]`. Stemplet vi — som før — bare en enkelt `adresse`-streng
   * her, ville den strengen deretter trippet `!enhet.adresse`-vaktposten i
   * `hentAdresserFor`, og enheten hadde stått som én `gnr/bnr`-chip for alltid.
   * `extractAdresse` plukker dessuten «første treff vinner» ut av en adresseliste,
   * så valget av hvilken av andelene som ble etiketten var vilkårlig.
   *
   * Er det ingen vegadresser å hente, faller vi tilbake til den etablerte
   * enkeltstreng-veien: den tåler skjeve responsformer
   * `getAdresserForMatrikkelenhet` ikke dekker (tall, nøstede lister — se
   * `extractAdresse`).
   */
  async enrichAdresseIfMissing(e, r) {
    if (e.adresse || e.adresser)
      return;
    const n = await rr(this.apiUrl, r, this.token), s = n.filter(Ys);
    if (s.length > 1) {
      e.adresser = n;
      return;
    }
    if (s.length === 1) {
      e.adresse = s[0].tekst;
      return;
    }
    const i = await this.fetchAdresseForMatrikkelenhetId(r);
    i && (e.adresse = i);
  }
  async fetchAdresseForMatrikkelenhetId(e) {
    try {
      const r = await yt(this.apiUrl, e, this.token, "adresse");
      return this.extractAdresse(r);
    } catch {
      return;
    }
  }
  extractAdresse(e) {
    if (e) {
      if (typeof e == "number")
        return Number.isFinite(e) ? String(e) : void 0;
      if (typeof e == "string") {
        const r = e.trim();
        return r.length > 0 ? r : void 0;
      }
      if (Array.isArray(e)) {
        for (const r of e) {
          const n = this.extractAdresse(r);
          if (n)
            return n;
        }
        return;
      }
      if (typeof e == "object") {
        const r = e, n = this.composeAdresseFromParts(r);
        if (n)
          return n;
        const s = ["adresse", "adressetekst", "adresseTekst", "fullAdresse", "vegadresse"];
        for (const o of s) {
          const c = this.extractAdresse(r[o]);
          if (c)
            return c;
        }
        const i = ["adresser", "adresseListe", "adresseList", "eiendommer", "results", "items"];
        for (const o of i) {
          const c = this.extractAdresse(r[o]);
          if (c)
            return c;
        }
      }
    }
  }
  composeAdresseFromParts(e) {
    const r = this.extractAdresse(
      e.adressenavn ?? e.vegnavn ?? e.gatenavn ?? e.streetName ?? e.street
    ), n = this.extractAdresse(
      e.husnummer ?? e.houseNumber ?? e.nummer ?? e.nr
    ), s = this.extractAdresse(
      e.undernummer ?? e.subNumber ?? e.underNr
    ), i = this.extractAdresse(
      e.husbokstav ?? e.bokstav ?? e.letter ?? e.houseLetter
    ), c = `${`${n ?? ""}${s ?? ""}`.trim()}${i ?? ""}`.trim();
    if (!(!r && !c))
      return r ? c ? `${r} ${c}` : r : c;
  }
  findMatrikkelenhetById(e, r, n) {
    for (const s of e) {
      const i = s.adresse ?? n;
      if (s.matrikkelenhetId === r)
        return !s.adresse && i && (s.adresse = i), s;
      if (Array.isArray(s.seksjoner) && s.seksjoner.length > 0) {
        const o = this.findMatrikkelenhetById(s.seksjoner, r, i);
        if (o)
          return o;
      }
    }
  }
  /**
   * Henter den stabile koblingsnøkkelen pr. graphic. Den faktiske derivasjonen
   * (LOKALID || `OBJTYPE:OBJECTID`-komposit for delomrader, eller stringifisert
   * Områder-id for egendefinerte) gjøres oppstrøms i admin (se
   * `selectedPlanGeometrySlice.ts` og `AdminPage.handleSelect`). Her er
   * `attrs.omradeid` allerede den ferdige strengen — vi stoler på det og
   * stringifiserer for sikkerhets skyld (legacy-data kan være nummer).
   */
  getOmradeIds(e) {
    const r = e.map((n) => {
      const i = n.attributes?.omradeid;
      if (i == null)
        return;
      const o = String(i).trim();
      return o === "" ? void 0 : o;
    }).filter((n) => n !== void 0);
    return [...new Set(r)];
  }
  /**
   * Leser områdetypen fra graphic-attributtene (admin setter den per nivå:
   * 'plan' | 'delomrade' | 'delomradegruppe' | 'egendefinert'). Brukes som
   * `omradetype`-felt ved persistering og i where-klausuler. Defaulter til
   * 'delomrade' når den mangler (legacy/bakoverkompatibilitet).
   */
  getOmradetype(e) {
    for (const r of e) {
      const s = r.attributes?.omradetype;
      if (typeof s == "string" && s.trim() !== "")
        return s.trim();
    }
    return "delomrade";
  }
  getPersistedAddedMatrikkelenhetIds(e) {
    const r = /* @__PURE__ */ new Set();
    for (const [n, s] of e.perMatrikkelenhet.entries())
      s.some((i) => i.operation === U.add) && r.add(n);
    return r;
  }
  /**
   * Bygg WHERE-klausulen som identifiserer ALLE rader for én relasjon
   * (teigId, matrikkelenhetId, omradeid, omradetype) — uavhengig av operation.
   * Brukes av den idempotente skrivingen for å finne eksisterende rader.
   */
  /**
   * Returnerer enhetene som ble registrert på MINST én teig. Kartklikk-veien
   * trenger nøyaktig det utvalget: en enhet som ble filtrert bort (`filter` +
   * `filterTeiger`) eller som mangler teiger skal verken hente adresser eller
   * havne i baselinen — da ville den blitt en nedtonet «fjernet»-chip ingen har
   * fjernet. Retur-verdien er tilleggsinformasjon; alle andre kallere ignorerer den.
   */
  setTeiger(e, r, n = []) {
    if (e == null)
      return [];
    const s = Array.isArray(e) ? e : [e], i = [];
    return s.forEach((o) => {
      let c = !1;
      o.teigIds?.forEach((l) => {
        if (!r || n.includes(l)) {
          const u = this.teiger.get(l);
          u ? this.teiger.set(l, [...u, o]) : this.teiger.set(l, [o]), c = !0;
        }
      }), c && i.push(o);
    }), i;
  }
  isHovedEiendom(e) {
    return e.filter(
      (n) => n.type === "graphic" && n.graphic.layer === this.naboLayer && n.graphic.attributes.type === "hovedeiendom"
    ).map((n) => n).length >= 1;
  }
  /**
   * Bygg settet av teiger som overlapper kilde-geometrien (det valgte
   * delområdet) med et reelt areal. Returnerer `keepTeigIds: null` når
   * filtrering ikke er mulig (mangler kilde-geometri eller SR) — da beholdes
   * alt (fail-open). `teigGeometryById` gjenbrukes av `addMatrikkelEnheterToMap`
   * så geometriene ikke hentes to ganger.
   */
  async computeOverlappingTeiger(e, r) {
    const n = r.map((h) => h.geometry).filter((h) => !!h).map((h) => h.type ? h : ft.fromJSON(h)), s = /* @__PURE__ */ new Set();
    for (const h of e)
      if (!(h.status !== "fulfilled" || !h.value)) {
        for (const w of h.value)
          if (w.gardsnr !== 0) {
            for (const b of w.teigIds ?? [])
              s.add(b);
            for (const b of w.seksjoner ?? [])
              for (const p of b.teigIds ?? [])
                s.add(p);
          }
      }
    const i = this.mapView?.spatialReference, o = i?.wkid;
    if (n.length === 0 || !i || o == null || s.size === 0)
      return { keepTeigIds: null, teigGeometryById: /* @__PURE__ */ new Map() };
    if (!le.isLoaded())
      try {
        await le.load();
      } catch (h) {
        console.warn("Kunne ikke laste projectOperator for overlapp-filter", h);
      }
    const c = n.map((h) => {
      if (h.spatialReference?.wkid === o)
        return h;
      try {
        return le.execute(h, i) ?? h;
      } catch {
        return h;
      }
    }), l = await $e(this.apiUrl, [...s], o, this.token), u = new Map(l.map((h) => [h.teigId, h.polygon])), f = /* @__PURE__ */ new Set();
    for (const { teigId: h, polygon: w } of l)
      c.some((b) => ri(b, w)) && f.add(h);
    for (const h of s)
      u.has(h) || f.add(h);
    return { keepTeigIds: f, teigGeometryById: u };
  }
  async addMatrikkelEnheterToMap(e, r, n) {
    if (!e || e.length === 0)
      return;
    const s = this.mapView.spatialReference.wkid;
    if (s == null)
      return;
    const i = new Map(n ?? []), o = e.filter((l) => !i.has(l));
    if (o.length > 0) {
      const l = await $e(this.apiUrl, o, s, this.token);
      for (const { teigId: u, polygon: f } of l)
        i.set(u, f);
    }
    const c = e.map((l) => {
      const u = i.get(l);
      return u ? new st({ geometry: u, attributes: { id: l, gids: String(l) } }) : null;
    }).filter((l) => l !== null);
    await this.addGraphics(c, r);
  }
  async addGraphics(e, r) {
    for (const n of e)
      n.attributes.type = r;
    if (e.length > 0) {
      const s = ((await this.naboLayer.applyEdits({ addFeatures: e }))?.addFeatureResults ?? []).filter((i) => i?.error);
      if (s.length > 0) {
        const i = s[0]?.error?.message;
        console.warn(`[NaboListeService] applyEdits avviste ${s.length}/${e.length} grafikker:`, i);
      }
    }
  }
  async deleteGraphics(e) {
    e.length > 0 && await this.naboLayer.applyEdits({
      deleteFeatures: e
    });
  }
  async getNaboerFromHitResults(e) {
    return e.filter(
      (r) => r.type === "graphic" && r.graphic.layer === this.naboLayer && r.graphic.attributes.type === "nabo"
    ).map((r) => r.graphic);
  }
  async getNabokandidaterFromHitResults(e) {
    const r = await this.getEiendomsLayer();
    return e.filter(
      (n) => n.type === "graphic" && n.graphic.layer === r
    ).map((n) => n.graphic);
  }
  async getEiendomsLayer() {
    if (this.eiendomslayer)
      return this.eiendomslayer;
    await ln(() => !this.mapView.updating);
    const e = this.mapView;
    if (!e.map)
      throw new Error("Map is not initialized.");
    return e.map.findLayerById(this.eiendomsLayerId);
  }
  createClientSideFeatureLayer(e) {
    const r = new nt({
      color: [60, 120, 120, 0.35],
      outline: { color: [60, 120, 120, 1], width: 2 }
    }), n = new nt({
      color: [120, 240, 240, 0.35],
      outline: { color: [120, 240, 240, 1], width: 2 }
    });
    return new an({
      title: "Naboer",
      source: [],
      geometryType: "polygon",
      spatialReference: e,
      objectIdField: "objectId",
      outFields: ["*"],
      popupTemplate: {
        content: (s) => s.graphic.attributes.type
      },
      renderer: new cn({
        field: "type",
        uniqueValueInfos: [{
          value: "nabo",
          symbol: n
        }, {
          value: "hovedeiendom",
          symbol: r
        }]
      }),
      fields: [{
        name: "objectId",
        type: "oid"
      }, {
        name: "gids",
        type: "string"
      }, {
        // teigId (matrikkel) overstiger 32-bit (esriFieldTypeInteger, maks
        // 2 147 483 647) — moderne teigId-er er ~6,5 mrd. Med "integer" avviste
        // applyEdits stille alle grafikker med stor teigId, så de havnet i lista
        // men ble aldri malt. "big-integer" (64-bit) rommer dem.
        name: "id",
        type: "big-integer"
      }, {
        name: "type",
        type: "string"
      }]
    });
  }
  constructWhereClause(e, r) {
    return e.length === 1 ? `${r}=${e[0]}` : `${r} IN (${e.join(",")})`;
  }
  flashGeometry(e) {
    const r = new nt({
      color: [0, 0, 0, 0],
      outline: { color: [255, 0, 255, 255], width: 3 }
    }), n = new st({ geometry: e, symbol: r }), s = () => this.mapView.graphics.add(n), i = () => this.mapView.graphics.remove(n);
    s(), setTimeout(i, 350), setTimeout(s, 700), setTimeout(i, 1050);
  }
  /**
   * Varsle React-laget om at eiendomslista er endret (erstatter tidligere
   * window-event) — og i samme åndedrag om hvilke enheter som er FJERNET.
   *
   * Fjernet-settet UTLEDES her (baseline minus aktive) i stedet for å bokføres
   * inkrementelt i de fire kall-stedene som muterer `this.teiger`. Da kan de to
   * listene ikke desynce, som er den samme invarianten de direkte callbackene
   * ble innført for.
   */
  emitState() {
    if (!this.onChange)
      return;
    const e = [...new Set([...this.teiger.values()].flat())];
    this.onChange({
      eiendommer: e,
      fjernedeEnheter: this.beregnFjernedeEnheter(e),
      fjernedeAdresser: this.beregnFjernedeAdresser(),
      saving: this.savingCount > 0
    });
  }
  /** Fjernede adresser (13928) — oppslag i baselinen for hver fjernet id. */
  beregnFjernedeAdresser() {
    const e = [];
    for (const r of this.fjernedeAdresseIds) {
      const n = this.baselineAdresser.get(r);
      n && e.push(n);
    }
    return e;
  }
  /** Baseline-enheter som ikke lenger er i utvalget — kandidater for «legg tilbake». */
  beregnFjernedeEnheter(e) {
    const r = new Set(e.map((n) => n.matrikkelenhetId));
    return [...this.baselineEnheter.values()].filter(({ enhet: n }) => !r.has(n.matrikkelenhetId)).map(({ enhet: n, teigIds: s }) => ({ enhet: n, baselineTeigIds: [...s] }));
  }
}
class si {
  constructor() {
    this.tokenInfo = void 0, this.tokenFeatureLayer = void 0;
  }
  async getToken() {
    return this.tokenFeatureLayer || (this.tokenFeatureLayer = await this.getTokenLayer()), this.isTokenInfoValid(this.tokenInfo) || (this.tokenInfo = await this.getTokenInfo()), this.tokenInfo?.token;
  }
  async getTokenInfo() {
    if (this.tokenFeatureLayer) {
      const r = (await this.tokenFeatureLayer.queryFeatures({
        returnGeometry: !1,
        outFields: ["*"]
      })).features[0];
      return {
        token: r.attributes.token,
        expires: new Date(r.attributes.expires)
      };
    }
  }
  isTokenInfoValid(e) {
    if (e == null)
      return !1;
    const r = e.expires.getTime() - (/* @__PURE__ */ new Date()).getTime(), n = 1e3 * 60 * 5;
    return r >= n;
  }
  async getTokenLayer() {
    if (this.tokenFeatureLayer)
      return this.tokenFeatureLayer;
    let e = new mn({
      id: "7159c11acc8049cd9b618fdc3650570a"
    });
    return await pn.fromPortalItem({
      portalItem: e
    });
  }
}
const Ci = new si();
class ii {
  constructor(e) {
    this.config = e;
  }
  /**
   * Get authentication token
   * @throws Error if no token is available
   */
  async getToken() {
    const e = await this.config.getToken();
    if (!e)
      throw new Error("No authentication token available");
    return e;
  }
  /**
   * Get MatrikkelEnhet from geometry
   */
  async getMatrikkelEnhetFromGeometry(e) {
    const r = await this.getToken(), n = `${this.config.apiUrl}/Matrikkelenhet/finnvedgeometri`;
    try {
      return (await H.post(
        `${n}?Token=${r}`,
        { geometry: e },
        {
          timeout: this.config.timeout || 3e4,
          headers: {
            "Content-Type": "application/json"
          }
        }
      )).data.eiendommer;
    } catch (s) {
      throw console.error("Error fetching MatrikkelEnhet from geometry:", s), s;
    }
  }
  /**
   * Query MatrikkelEnhet by ID
   */
  async queryMatrikkelenhet(e, r, n) {
    const s = await this.getToken(), i = `${this.config.apiUrl}/matrikkelenhet/${e}${r ? "/" + r : ""}`;
    try {
      return (await H.get(i, {
        params: { token: s },
        timeout: this.config.timeout || 3e4,
        signal: n?.signal
      })).data;
    } catch (o) {
      throw H.isCancel(o) ? o : (console.error("Error querying MatrikkelEnhet:", o), new Error("Feil med henting av matrikkelinformasjon. Prøv igjen."));
    }
  }
  /**
   * Matrikkelenhetene en vegadresse er knyttet til (adresse/{id}/matrikkelenhet).
   * For adresser på seksjonerte eiendommer inneholder listen typisk både
   * grunneiendommen og matrikkelseksjonen(e) — brukes av publikums
   * identitetsberikelse (F21).
   */
  async getMatrikkelenheterForAdresse(e, r) {
    const n = await this.getToken(), s = `${this.config.apiUrl}/adresse/${e}/matrikkelenhet`;
    try {
      return (await H.get(s, {
        params: { token: n },
        timeout: this.config.timeout || 3e4,
        signal: r?.signal
      })).data?.matrikkelenheter ?? [];
    } catch (i) {
      throw H.isCancel(i) ? i : (console.error("Error fetching matrikkelenheter for adresse:", i), new Error("Failed to get matrikkelenheter for adresse"));
    }
  }
  /**
   * Fetch all street addresses for a matrikkelenhet (handles units with multiple addresses)
   */
  async getAllAdresser(e) {
    const r = await this.queryMatrikkelenhet(e, "adresse");
    return Xs(r);
  }
  /**
   * Get MatrikkelEnhet ID from matrikkel numbers
   */
  async getMatrikkelEnhetId(e, r, n, s = 0, i = 0, o) {
    const c = await this.getToken(), l = `${this.config.apiUrl}/Matrikkelenhet/matrikkelenhetid`;
    try {
      return (await H.get(l, {
        params: {
          Kommunenummer: e,
          Gardsnummer: r,
          Bruksnummer: n,
          Festenummer: s,
          Seksjonsnummer: i,
          token: c
        },
        timeout: this.config.timeout || 3e4,
        signal: o?.signal
      })).data.matrikkelenhetId;
    } catch (u) {
      throw H.isCancel(u) ? u : (console.error("Error getting MatrikkelEnhetId:", u), new Error("Failed to get matrikkelEnhetId"));
    }
  }
  /**
   * Open Matrikkel rapport in new window
   */
  async openMatrikkelrapport(e) {
    try {
      const r = await this.getToken(), n = `${this.config.apiUrl}/matrikkelenhet/${e}/rapport?token=${r}`;
      window.open(n);
    } catch (r) {
      console.error("Error opening Matrikkelrapport:", r);
    }
  }
  /**
   * Open Grunnbok rapport in new window
   */
  async openGrunnbokrapport(e) {
    try {
      const r = await this.getToken(), n = `${this.config.apiUrl}/grunnbok/kartverket/rapport?kommunenummer=${e.knr}&gardsnummer=${e.gnr}&bruksnummer=${e.bnr}&festenummer=${e.fnr}&seksjonsnummer=${e.snr}&token=${r}`;
      window.open(n);
    } catch (r) {
      console.error("Error opening Grunnbokrapport:", r);
    }
  }
}
const Fi = (t) => new ii(t);
var kt = { exports: {} }, be = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ir;
function oi() {
  if (ir)
    return be;
  ir = 1;
  var t = ar, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(c, l, u) {
    var f, h = {}, w = null, b = null;
    u !== void 0 && (w = "" + u), l.key !== void 0 && (w = "" + l.key), l.ref !== void 0 && (b = l.ref);
    for (f in l)
      n.call(l, f) && !i.hasOwnProperty(f) && (h[f] = l[f]);
    if (c && c.defaultProps)
      for (f in l = c.defaultProps, l)
        h[f] === void 0 && (h[f] = l[f]);
    return { $$typeof: e, type: c, key: w, ref: b, props: h, _owner: s.current };
  }
  return be.Fragment = r, be.jsx = o, be.jsxs = o, be;
}
var ve = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var or;
function ai() {
  return or || (or = 1, process.env.NODE_ENV !== "production" && function() {
    var t = ar, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function y(a) {
      if (a === null || typeof a != "object")
        return null;
      var m = p && a[p] || a[g];
      return typeof m == "function" ? m : null;
    }
    var A = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(a) {
      {
        for (var m = arguments.length, k = new Array(m > 1 ? m - 1 : 0), v = 1; v < m; v++)
          k[v - 1] = arguments[v];
        I("error", a, k);
      }
    }
    function I(a, m, k) {
      {
        var v = A.ReactDebugCurrentFrame, O = v.getStackAddendum();
        O !== "" && (m += "%s", k = k.concat([O]));
        var C = k.map(function(R) {
          return String(R);
        });
        C.unshift("Warning: " + m), Function.prototype.apply.call(console[a], console, C);
      }
    }
    var x = !1, q = !1, Q = !1, $ = !1, pe = !1, ee;
    ee = Symbol.for("react.module.reference");
    function Re(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === n || a === i || pe || a === s || a === u || a === f || $ || a === b || x || q || Q || typeof a == "object" && a !== null && (a.$$typeof === w || a.$$typeof === h || a.$$typeof === o || a.$$typeof === c || a.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === ee || a.getModuleId !== void 0));
    }
    function Ae(a, m, k) {
      var v = a.displayName;
      if (v)
        return v;
      var O = m.displayName || m.name || "";
      return O !== "" ? k + "(" + O + ")" : k;
    }
    function te(a) {
      return a.displayName || "Context";
    }
    function _(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case c:
            var m = a;
            return te(m) + ".Consumer";
          case o:
            var k = a;
            return te(k._context) + ".Provider";
          case l:
            return Ae(a, a.render, "ForwardRef");
          case h:
            var v = a.displayName || null;
            return v !== null ? v : _(a.type) || "Memo";
          case w: {
            var O = a, C = O._payload, R = O._init;
            try {
              return _(R(C));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var L = Object.assign, Z = 0, W, me, G, ge, Oe, z, X;
    function ie() {
    }
    ie.__reactDisabledLog = !0;
    function oe() {
      {
        if (Z === 0) {
          W = console.log, me = console.info, G = console.warn, ge = console.error, Oe = console.group, z = console.groupCollapsed, X = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: ie,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        Z++;
      }
    }
    function Ie() {
      {
        if (Z--, Z === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: L({}, a, {
              value: W
            }),
            info: L({}, a, {
              value: me
            }),
            warn: L({}, a, {
              value: G
            }),
            error: L({}, a, {
              value: ge
            }),
            group: L({}, a, {
              value: Oe
            }),
            groupCollapsed: L({}, a, {
              value: z
            }),
            groupEnd: L({}, a, {
              value: X
            })
          });
        }
        Z < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Je = A.ReactCurrentDispatcher, Ke;
    function Ce(a, m, k) {
      {
        if (Ke === void 0)
          try {
            throw Error();
          } catch (O) {
            var v = O.stack.trim().match(/\n( *(at )?)/);
            Ke = v && v[1] || "";
          }
        return `
` + Ke + a;
      }
    }
    var Ye = !1, Fe;
    {
      var _r = typeof WeakMap == "function" ? WeakMap : Map;
      Fe = new _r();
    }
    function At(a, m) {
      if (!a || Ye)
        return "";
      {
        var k = Fe.get(a);
        if (k !== void 0)
          return k;
      }
      var v;
      Ye = !0;
      var O = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var C;
      C = Je.current, Je.current = null, oe();
      try {
        if (m) {
          var R = function() {
            throw Error();
          };
          if (Object.defineProperty(R.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(R, []);
            } catch (D) {
              v = D;
            }
            Reflect.construct(a, [], R);
          } else {
            try {
              R.call();
            } catch (D) {
              v = D;
            }
            a.call(R.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (D) {
            v = D;
          }
          a();
        }
      } catch (D) {
        if (D && v && typeof D.stack == "string") {
          for (var T = D.stack.split(`
`), N = v.stack.split(`
`), F = T.length - 1, P = N.length - 1; F >= 1 && P >= 0 && T[F] !== N[P]; )
            P--;
          for (; F >= 1 && P >= 0; F--, P--)
            if (T[F] !== N[P]) {
              if (F !== 1 || P !== 1)
                do
                  if (F--, P--, P < 0 || T[F] !== N[P]) {
                    var V = `
` + T[F].replace(" at new ", " at ");
                    return a.displayName && V.includes("<anonymous>") && (V = V.replace("<anonymous>", a.displayName)), typeof a == "function" && Fe.set(a, V), V;
                  }
                while (F >= 1 && P >= 0);
              break;
            }
        }
      } finally {
        Ye = !1, Je.current = C, Ie(), Error.prepareStackTrace = O;
      }
      var ce = a ? a.displayName || a.name : "", re = ce ? Ce(ce) : "";
      return typeof a == "function" && Fe.set(a, re), re;
    }
    function Mr(a, m, k) {
      return At(a, !1);
    }
    function Lr(a) {
      var m = a.prototype;
      return !!(m && m.isReactComponent);
    }
    function Pe(a, m, k) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return At(a, Lr(a));
      if (typeof a == "string")
        return Ce(a);
      switch (a) {
        case u:
          return Ce("Suspense");
        case f:
          return Ce("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case l:
            return Mr(a.render);
          case h:
            return Pe(a.type, m, k);
          case w: {
            var v = a, O = v._payload, C = v._init;
            try {
              return Pe(C(O), m, k);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, Ot = {}, It = A.ReactDebugCurrentFrame;
    function je(a) {
      if (a) {
        var m = a._owner, k = Pe(a.type, a._source, m ? m.type : null);
        It.setExtraStackFrame(k);
      } else
        It.setExtraStackFrame(null);
    }
    function Nr(a, m, k, v, O) {
      {
        var C = Function.call.bind(ye);
        for (var R in a)
          if (C(a, R)) {
            var T = void 0;
            try {
              if (typeof a[R] != "function") {
                var N = Error((v || "React class") + ": " + k + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw N.name = "Invariant Violation", N;
              }
              T = a[R](m, R, v, k, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (F) {
              T = F;
            }
            T && !(T instanceof Error) && (je(O), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", k, R, typeof T), je(null)), T instanceof Error && !(T.message in Ot) && (Ot[T.message] = !0, je(O), E("Failed %s type: %s", k, T.message), je(null));
          }
      }
    }
    var $r = Array.isArray;
    function Qe(a) {
      return $r(a);
    }
    function Dr(a) {
      {
        var m = typeof Symbol == "function" && Symbol.toStringTag, k = m && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return k;
      }
    }
    function Ur(a) {
      try {
        return Ct(a), !1;
      } catch {
        return !0;
      }
    }
    function Ct(a) {
      return "" + a;
    }
    function Ft(a) {
      if (Ur(a))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Dr(a)), Ct(a);
    }
    var ke = A.ReactCurrentOwner, Br = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Pt, jt, Xe;
    Xe = {};
    function qr(a) {
      if (ye.call(a, "ref")) {
        var m = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function Wr(a) {
      if (ye.call(a, "key")) {
        var m = Object.getOwnPropertyDescriptor(a, "key").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function Vr(a, m) {
      if (typeof a.ref == "string" && ke.current && m && ke.current.stateNode !== m) {
        var k = _(ke.current.type);
        Xe[k] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _(ke.current.type), a.ref), Xe[k] = !0);
      }
    }
    function Hr(a, m) {
      {
        var k = function() {
          Pt || (Pt = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        k.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: k,
          configurable: !0
        });
      }
    }
    function Gr(a, m) {
      {
        var k = function() {
          jt || (jt = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        k.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: k,
          configurable: !0
        });
      }
    }
    var zr = function(a, m, k, v, O, C, R) {
      var T = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: a,
        key: m,
        ref: k,
        props: R,
        // Record the component responsible for creating this element.
        _owner: C
      };
      return T._store = {}, Object.defineProperty(T._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(T, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(T, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: O
      }), Object.freeze && (Object.freeze(T.props), Object.freeze(T)), T;
    };
    function Jr(a, m, k, v, O) {
      {
        var C, R = {}, T = null, N = null;
        k !== void 0 && (Ft(k), T = "" + k), Wr(m) && (Ft(m.key), T = "" + m.key), qr(m) && (N = m.ref, Vr(m, O));
        for (C in m)
          ye.call(m, C) && !Br.hasOwnProperty(C) && (R[C] = m[C]);
        if (a && a.defaultProps) {
          var F = a.defaultProps;
          for (C in F)
            R[C] === void 0 && (R[C] = F[C]);
        }
        if (T || N) {
          var P = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          T && Hr(R, P), N && Gr(R, P);
        }
        return zr(a, T, N, O, v, ke.current, R);
      }
    }
    var Ze = A.ReactCurrentOwner, xt = A.ReactDebugCurrentFrame;
    function ae(a) {
      if (a) {
        var m = a._owner, k = Pe(a.type, a._source, m ? m.type : null);
        xt.setExtraStackFrame(k);
      } else
        xt.setExtraStackFrame(null);
    }
    var et;
    et = !1;
    function tt(a) {
      return typeof a == "object" && a !== null && a.$$typeof === e;
    }
    function _t() {
      {
        if (Ze.current) {
          var a = _(Ze.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function Kr(a) {
      {
        if (a !== void 0) {
          var m = a.fileName.replace(/^.*[\\\/]/, ""), k = a.lineNumber;
          return `

Check your code at ` + m + ":" + k + ".";
        }
        return "";
      }
    }
    var Mt = {};
    function Yr(a) {
      {
        var m = _t();
        if (!m) {
          var k = typeof a == "string" ? a : a.displayName || a.name;
          k && (m = `

Check the top-level render call using <` + k + ">.");
        }
        return m;
      }
    }
    function Lt(a, m) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var k = Yr(m);
        if (Mt[k])
          return;
        Mt[k] = !0;
        var v = "";
        a && a._owner && a._owner !== Ze.current && (v = " It was passed a child from " + _(a._owner.type) + "."), ae(a), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', k, v), ae(null);
      }
    }
    function Nt(a, m) {
      {
        if (typeof a != "object")
          return;
        if (Qe(a))
          for (var k = 0; k < a.length; k++) {
            var v = a[k];
            tt(v) && Lt(v, m);
          }
        else if (tt(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var O = y(a);
          if (typeof O == "function" && O !== a.entries)
            for (var C = O.call(a), R; !(R = C.next()).done; )
              tt(R.value) && Lt(R.value, m);
        }
      }
    }
    function Qr(a) {
      {
        var m = a.type;
        if (m == null || typeof m == "string")
          return;
        var k;
        if (typeof m == "function")
          k = m.propTypes;
        else if (typeof m == "object" && (m.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        m.$$typeof === h))
          k = m.propTypes;
        else
          return;
        if (k) {
          var v = _(m);
          Nr(k, a.props, "prop", v, a);
        } else if (m.PropTypes !== void 0 && !et) {
          et = !0;
          var O = _(m);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", O || "Unknown");
        }
        typeof m.getDefaultProps == "function" && !m.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Xr(a) {
      {
        for (var m = Object.keys(a.props), k = 0; k < m.length; k++) {
          var v = m[k];
          if (v !== "children" && v !== "key") {
            ae(a), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), ae(null);
            break;
          }
        }
        a.ref !== null && (ae(a), E("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    var $t = {};
    function Dt(a, m, k, v, O, C) {
      {
        var R = Re(a);
        if (!R) {
          var T = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (T += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var N = Kr(O);
          N ? T += N : T += _t();
          var F;
          a === null ? F = "null" : Qe(a) ? F = "array" : a !== void 0 && a.$$typeof === e ? (F = "<" + (_(a.type) || "Unknown") + " />", T = " Did you accidentally export a JSX literal instead of a component?") : F = typeof a, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", F, T);
        }
        var P = Jr(a, m, k, O, C);
        if (P == null)
          return P;
        if (R) {
          var V = m.children;
          if (V !== void 0)
            if (v)
              if (Qe(V)) {
                for (var ce = 0; ce < V.length; ce++)
                  Nt(V[ce], a);
                Object.freeze && Object.freeze(V);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nt(V, a);
        }
        if (ye.call(m, "key")) {
          var re = _(a), D = Object.keys(m).filter(function(sn) {
            return sn !== "key";
          }), rt = D.length > 0 ? "{key: someKey, " + D.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!$t[re + rt]) {
            var nn = D.length > 0 ? "{" + D.join(": ..., ") + ": ...}" : "{}";
            E(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, rt, re, nn, re), $t[re + rt] = !0;
          }
        }
        return a === n ? Xr(P) : Qr(P), P;
      }
    }
    function Zr(a, m, k) {
      return Dt(a, m, k, !0);
    }
    function en(a, m, k) {
      return Dt(a, m, k, !1);
    }
    var tn = en, rn = Zr;
    ve.Fragment = n, ve.jsx = tn, ve.jsxs = rn;
  }()), ve;
}
process.env.NODE_ENV === "production" ? kt.exports = oi() : kt.exports = ai();
var ci = kt.exports;
const xr = gn(null), Pi = () => {
  const t = yn(xr);
  if (!t)
    throw new Error("useMatrikkelClient must be used within MatrikkelClientProvider");
  return t;
}, ji = ({ children: t, client: e }) => /* @__PURE__ */ ci.jsx(xr.Provider, { value: e, children: t });
export {
  ct as GEOEIENDOM_ADRESSE_WKID,
  ii as MatrikkelClient,
  ji as MatrikkelClientProvider,
  Ii as NaboListeService,
  sr as TOMT_DELTASETT,
  Ci as TokenService,
  Fi as createMatrikkelClient,
  Ys as erVegadresse,
  Xs as extractAlleAdresser,
  Ti as fetchAllTeigGeometriesForMatrikkelenhet,
  rr as getAdresserForMatrikkelenhet,
  lt as getMatrikkelEnhetFromGeometry,
  Oi as getMatrikkelEnhetId,
  vi as getMatrikkelEnheterFinn,
  Ei as getMatrikkelenhetIdForTeig,
  $e as getTeigGeometries,
  ei as getTeigIdsForMatrikkelenhet,
  Si as getTeigerForMatrikkelenhet,
  Ai as openGrunnbokrapport,
  Ri as openMatrikkelrapport,
  Pr as parseAdresser,
  yt as queryMatrikkelenhet,
  bi as toMatrikkelID,
  Pi as useMatrikkelClient
};
//# sourceMappingURL=index.mjs.map
